export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

export type AcceptInvitationInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  userFunction: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AcceptRecyclerInvoiceToProducerRequestAndCreateMaterialInput = {
  recyclerId: Scalars['ID']['input'];
  responseId: Scalars['String']['input'];
};

export type AccessibilityIncidentGraphql = IncidentGraphql & {
  __typename?: 'AccessibilityIncidentGraphql';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUser: UserGraphql;
  documents: StoredDocumentCollection;
  id: Scalars['ID']['output'];
  penaltyAmount?: Maybe<Scalars['Float']['output']>;
  penaltyComment?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  status: IncidentStatus;
  type: IncidentType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AccessibilityIncidentGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type AddNewMaterialPricingGraphqlInput = {
  price: Scalars['Float']['input'];
  recyclerId: Scalars['ID']['input'];
  source: PricingSourceType;
  standardMaterialId: Scalars['ID']['input'];
  targetProducerId?: InputMaybe<Scalars['ID']['input']>;
  updateFrequency: UpdateFrequencyGraphql;
  vat: Scalars['Float']['input'];
};

export type AddressGraphql = {
  __typename?: 'AddressGraphql';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export enum AscDescGraphql {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type AssignRoleInput = {
  /** Has no effect when user is NOT Cinqo admin. */
  organizationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type AssignedRoleGraphql = {
  __typename?: 'AssignedRoleGraphql';
  id: Scalars['ID']['output'];
  role: RoleGraphql;
  user: UserGraphql;
};

export type AssignedRolesCollection = {
  __typename?: 'AssignedRolesCollection';
  collection: Array<Maybe<AssignedRoleGraphql>>;
  count: Scalars['Float']['output'];
};

export type AvailableCategories = {
  __typename?: 'AvailableCategories';
  category: Scalars['String']['output'];
  subcategories: Array<Maybe<Scalars['String']['output']>>;
};

export type BsdCollection = {
  __typename?: 'BSDCollection';
  collection: Array<Maybe<BsdGraphql>>;
  count: Scalars['Float']['output'];
};

export type BsdCollectionGraphql = {
  __typename?: 'BSDCollectionGraphql';
  collection: Array<Maybe<BsdGraphql>>;
  count: Scalars['Float']['output'];
};

export type BsdFiltersGraphql = {
  bsdIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  collectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Admin-only. */
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  publicStates?: InputMaybe<Array<CollectBsdState>>;
  tdStates?: InputMaybe<Array<TrackdechetsBsdState>>;
};

export type BsdGraphql = {
  __typename?: 'BSDGraphql';
  TDViewBSDUri?: Maybe<Scalars['String']['output']>;
  /** All the containers containing this BSD material. */
  collectedContainers: Array<CollectedContainerGraphql>;
  /** Public download URI. Can only be used when the underlying BSD is not in DRAFT state. Valid 10 seconds. */
  downloadURI?: Maybe<Scalars['String']['output']>;
  errors: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The material in all containers referenced in this BSD */
  material: MaterialGraphql;
  /** Public download URI. Can only be used when the underlying BSD has been signed after pickup by a transporter. Valid 30 minutes. */
  publicDownloadURI?: Maybe<Scalars['String']['output']>;
  publicState: CollectBsdState;
  /** @deprecated use publicState */
  state: CollectBsdState;
  tdState: TrackdechetsBsdState;
};

export type Co2Saved = {
  __typename?: 'CO2Saved';
  totalCO2Saved: Scalars['Float']['output'];
};

export type CancelCollectInputGraphql = {
  collectId: Scalars['ID']['input'];
};

export type ClientAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type ClientCollection = {
  __typename?: 'ClientCollection';
  collection: Array<Maybe<ClientGraphql>>;
  count: Scalars['Float']['output'];
};

export type ClientCustomDashboardInputGraphql = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  dark?: InputMaybe<Scalars['Boolean']['input']>;
  /** Admin only. Fetches any dashboard on metabase. */
  dashboardId?: InputMaybe<Scalars['ID']['input']>;
};

export type ClientDocumentGraphql = StoredDocumentGraphql & {
  __typename?: 'ClientDocumentGraphql';
  client: ClientGraphql;
  createdAt: Scalars['DateTime']['output'];
  documentContentRaw?: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  externalReference: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  /** if provided by the user, the sub-category of document */
  subtype?: Maybe<DocumentMetaSubtypes>;
  tags: Array<Maybe<DocumentTagGraphql>>;
  type: DocumentType;
};

export type ClientFilterGraphql = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Uses a full text search on all clients */
  search?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  types?: InputMaybe<Array<ClientType>>;
};

export type ClientGraphql = {
  address?: Maybe<AddressGraphql>;
  autosignEnabledForTrackdechets: Scalars['Boolean']['output'];
  bic?: Maybe<Scalars['String']['output']>;
  companyLogo?: Maybe<ClientDocumentGraphql>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  customDashboard?: Maybe<Scalars['String']['output']>;
  customDashboardId?: Maybe<Scalars['Float']['output']>;
  documents: StoredDocumentCollection;
  /** True if the client has collects either as a producer or a recycler */
  hasCollects: Scalars['Boolean']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isConnectedToTrackdechets?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  onboardingDone?: Maybe<Scalars['Boolean']['output']>;
  onboardingNeeds?: Maybe<Scalars['String']['output']>;
  organization: OrganizationGraphql;
  paysMonthlyFees?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  siret?: Maybe<Scalars['String']['output']>;
  sites: SitesCollection;
  slug: Scalars['String']['output'];
  type: ClientType;
};


export type ClientGraphqlCustomDashboardArgs = {
  input?: InputMaybe<ClientCustomDashboardInputGraphql>;
};


export type ClientGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};


export type ClientGraphqlSitesArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type ClientInput = {
  bic?: InputMaybe<Scalars['String']['input']>;
  clientAddress?: InputMaybe<ClientAddressInput>;
  customDashboardId?: InputMaybe<Scalars['Float']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isPremiumRecycler?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingDone?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingNeeds?: InputMaybe<Array<Scalars['String']['input']>>;
  paysMonthlyFees?: InputMaybe<Scalars['Float']['input']>;
  percentageRecyclerRevshare?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  siret?: InputMaybe<Scalars['String']['input']>;
  transporterReceipt?: InputMaybe<Scalars['String']['input']>;
};

export enum ClientType {
  Cinqo = 'cinqo',
  Producer = 'producer',
  Recycler = 'recycler'
}

export enum CollectBsdState {
  Error = 'ERROR',
  Signed = 'SIGNED',
  ToSignByWp = 'TO_SIGN_BY_WP',
  ToSignByWr = 'TO_SIGN_BY_WR'
}

export type CollectCsvExtractGraphql = {
  __typename?: 'CollectCSVExtractGraphql';
  B64Csv: Scalars['String']['output'];
};

export type CollectCsvExtractInput = {
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
};

export type CollectDocumentFilters = {
  clientId?: InputMaybe<Scalars['Float']['input']>;
  clientIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  collectDateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  collectDateStart?: InputMaybe<Scalars['DateTime']['input']>;
  collectId?: InputMaybe<Scalars['Float']['input']>;
  collectStatuses?: InputMaybe<Array<CollectStatus>>;
  documentMetaSubtypes?: InputMaybe<Array<DocumentMetaSubtypes>>;
  documentName?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagFilter?: InputMaybe<DocumentTagFilter>;
};

export type CollectDocumentGraphql = StoredDocumentGraphql & {
  __typename?: 'CollectDocumentGraphql';
  client: ClientGraphql;
  collect: CollectGraphql;
  createdAt: Scalars['DateTime']['output'];
  documentContentRaw?: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  externalReference: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  /** if provided by the user, the sub-category of document */
  subtype?: Maybe<DocumentMetaSubtypes>;
  tags: Array<Maybe<DocumentTagGraphql>>;
  type: DocumentType;
};

export type CollectGraphql = {
  __typename?: 'CollectGraphql';
  /** Related Trackdechets BSDs */
  BSDs: BsdCollection;
  /** The Waste Producer of the collect */
  client: ClientGraphql;
  co2Amount?: Maybe<Scalars['Float']['output']>;
  /** The containers that are handled in this collect */
  collectedContainers: CollectedContainerCollection;
  createdAt: Scalars['DateTime']['output'];
  /** The end destination of the collect. */
  destination?: Maybe<SiteGraphql>;
  documents: StoredDocumentCollection;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Related incidents */
  incidents: IncidentCollection;
  isInvoiceable: CollectInvoiceGraphql;
  licensePlate?: Maybe<Scalars['String']['output']>;
  /** The location for the pickup of the collect. */
  location: SiteGraphql;
  /** The missing informations for the collect */
  missingInformations: Array<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<NotificationGraphql>;
  npsRating?: Maybe<NpsGraphql>;
  pricingSummary?: Maybe<CollectPricingSummaryGraphql>;
  /** Once assigned, the set recycler of the collect. */
  recycler?: Maybe<RecyclerGraphql>;
  referent: PartialUserGraphql;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: CollectStatus;
  transportPrice?: Maybe<Scalars['Float']['output']>;
};


export type CollectGraphqlBsDsArgs = {
  filters?: InputMaybe<CollectsBsDsFiltersGraphql>;
};


export type CollectGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};


export type CollectGraphqlPricingSummaryArgs = {
  input?: InputMaybe<PricingSummaryInputGraphql>;
};

export type CollectGraphqlFilters = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters by collects that have at least one BSD with these states */
  hasBSDWithTDStates?: InputMaybe<Array<TrackdechetsBsdState>>;
  /** Filter collects that have missing required fields (license plate, quantity, treatment code) */
  hasMissingFields?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<OrderByArgs>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter collects starting from this date */
  startsAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter collects starting before this date */
  startsAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<CollectStatus>>;
};

export type CollectInvoiceGraphql = {
  __typename?: 'CollectInvoiceGraphql';
  alreadyInvoiced: Scalars['Boolean']['output'];
  errors: Array<Maybe<Scalars['String']['output']>>;
  result: Scalars['Boolean']['output'];
};

export type CollectPricingSummaryDetailsGraphql = {
  __typename?: 'CollectPricingSummaryDetailsGraphql';
  incidentsTotalWithTax: Scalars['Float']['output'];
  incidentsTotalWithoutTax: Scalars['Float']['output'];
  totalResaleWithTax: Scalars['Float']['output'];
  totalResaleWithoutTax: Scalars['Float']['output'];
  totalTax: Scalars['Float']['output'];
  totalTreatmentWithTax: Scalars['Float']['output'];
  totalTreatmentWithoutTax: Scalars['Float']['output'];
  totalWithTax: Scalars['Float']['output'];
  totalWithoutTax: Scalars['Float']['output'];
  transportTotalWithTax: Scalars['Float']['output'];
  transportTotalWithoutTax: Scalars['Float']['output'];
};

export type CollectPricingSummaryGraphql = {
  __typename?: 'CollectPricingSummaryGraphql';
  ready: Scalars['Boolean']['output'];
  summary?: Maybe<CollectPricingSummaryDetailsGraphql>;
};

export enum CollectStatus {
  AdminInProgress = 'adminInProgress',
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Finished = 'finished',
  HasIncident = 'hasIncident',
  InTreatment = 'inTreatment',
  Invoicing = 'invoicing',
  PickupConfirmed = 'pickupConfirmed',
  RequestSent = 'requestSent',
  WpCancel = 'wpCancel',
  WrCancel = 'wrCancel'
}

export type CollectedContainerCollection = {
  __typename?: 'CollectedContainerCollection';
  collection: Array<Maybe<CollectedContainerGraphql>>;
  count: Scalars['Float']['output'];
};

export type CollectedContainerDocumentGraphql = StoredDocumentGraphql & {
  __typename?: 'CollectedContainerDocumentGraphql';
  client: ClientGraphql;
  collectedContainer: CollectedContainerGraphql;
  createdAt: Scalars['DateTime']['output'];
  documentContentRaw?: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  externalReference: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceCertainty?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  /** if provided by the user, the sub-category of document */
  subtype?: Maybe<DocumentMetaSubtypes>;
  tags: Array<Maybe<DocumentTagGraphql>>;
  type: DocumentType;
};

export type CollectedContainerGraphql = {
  __typename?: 'CollectedContainerGraphql';
  BSD?: Maybe<BsdGraphql>;
  collect: CollectGraphql;
  container?: Maybe<ContainerGraphql>;
  documents: StoredDocumentCollection;
  fillRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  material?: Maybe<MaterialGraphql>;
  missingInformations?: Maybe<Array<Scalars['String']['output']>>;
  pricingSummary: CollectPricingSummaryGraphql;
  quantity?: Maybe<Scalars['Float']['output']>;
  treatmentCode?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};


export type CollectedContainerGraphqlDocumentsArgs = {
  documentsFilters?: InputMaybe<StoredDocumentFilters>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type CollectedContainerGraphqlPricingSummaryArgs = {
  input?: InputMaybe<PricingSummaryInputGraphql>;
};

export type CollectedContainerGraphqlFilters = {
  collectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CollectsBsDsFiltersGraphql = {
  bsdTDStates?: InputMaybe<Array<TrackdechetsBsdState>>;
};

export type CollectsCollection = {
  __typename?: 'CollectsCollection';
  collection: Array<Maybe<CollectGraphql>>;
  count: Scalars['Float']['output'];
};

export type CollectsWithMissingFieldsFiltersGraphql = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CompanyOnboardingGraphql = {
  __typename?: 'CompanyOnboardingGraphql';
  done: Scalars['Boolean']['output'];
  onboardingItems?: Maybe<Array<CompanyOnboardingItemGraphql>>;
};

export type CompanyOnboardingInputGraphql = {
  returnEvenIfDone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanyOnboardingItemGraphql = {
  __typename?: 'CompanyOnboardingItemGraphql';
  done: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CompanyRole = RoleGraphql & {
  __typename?: 'CompanyRole';
  company: ClientGraphql;
  features?: Maybe<Array<FeatureGraphql>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompanySearchResultGraphql = {
  __typename?: 'CompanySearchResultGraphql';
  address?: Maybe<Scalars['String']['output']>;
  allowBSDASRITakeOverWithoutSignature?: Maybe<Scalars['Boolean']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  existsInCinqo: Scalars['Boolean']['output'];
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  naf?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  siret?: Maybe<Scalars['String']['output']>;
  transporterReceipt?: Maybe<TransporterReceiptGraphql>;
};

export type ComplianceBasicNodeGraphql = ComplianceNodeGraphql & {
  __typename?: 'ComplianceBasicNodeGraphql';
  category: Scalars['String']['output'];
  document?: Maybe<ClientDocumentGraphql>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  state?: Maybe<ComplianceNodeState>;
  value: Scalars['Boolean']['output'];
};

export type ComplianceDocumentNodeGraphql = ComplianceNodeGraphql & {
  __typename?: 'ComplianceDocumentNodeGraphql';
  category: Scalars['String']['output'];
  document: ClientDocumentGraphql;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  state?: Maybe<ComplianceNodeState>;
  value: Scalars['Boolean']['output'];
};

export type ComplianceLinkNodeGraphql = ComplianceNodeGraphql & {
  __typename?: 'ComplianceLinkNodeGraphql';
  category: Scalars['String']['output'];
  document?: Maybe<ClientDocumentGraphql>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  link: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  state?: Maybe<ComplianceNodeState>;
  value: Scalars['Boolean']['output'];
};

export type ComplianceNodeGraphql = {
  category: Scalars['String']['output'];
  document?: Maybe<ClientDocumentGraphql>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  state?: Maybe<ComplianceNodeState>;
  value: Scalars['Boolean']['output'];
};

export type ComplianceNodeGraphqlFilter = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
};

export type ComplianceNodeGraphqlInput = {
  documentId?: InputMaybe<Scalars['ID']['input']>;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  isDone?: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pageNodeId: Scalars['ID']['input'];
  state?: InputMaybe<ComplianceNodeState>;
};

export type ComplianceNodeGraphqlInputList = {
  clientId: Scalars['ID']['input'];
  nodes: Array<ComplianceNodeGraphqlInput>;
};

export enum ComplianceNodeState {
  NonApplicable = 'NON_APPLICABLE',
  NotRequired = 'NOT_REQUIRED',
  Required = 'REQUIRED'
}

export type ComplianceScoreGraphql = {
  __typename?: 'ComplianceScoreGraphql';
  category: Scalars['String']['output'];
  completedRequired: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  totalRequired: Scalars['Float']['output'];
};

export type ComplianceScoreGraphqlFilter = {
  clientId: Scalars['ID']['input'];
};

export type ComplianceStructureNodeGraphql = {
  __typename?: 'ComplianceStructureNodeGraphql';
  category: Scalars['String']['output'];
  hasDocumentLink: Scalars['Boolean']['output'];
  hasExternalPageLink: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type ContainerCollection = {
  __typename?: 'ContainerCollection';
  collection: Array<Maybe<ContainerGraphql>>;
  count: Scalars['Float']['output'];
};

export type ContainerDocumentGraphql = StoredDocumentGraphql & {
  __typename?: 'ContainerDocumentGraphql';
  client: ClientGraphql;
  createdAt: Scalars['DateTime']['output'];
  documentContentRaw?: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  externalReference: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  /** if provided by the user, the sub-category of document */
  subtype?: Maybe<DocumentMetaSubtypes>;
  tags: Array<Maybe<DocumentTagGraphql>>;
  type: DocumentType;
};

export type ContainerFiltersGraphql = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  containerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ContainerGraphql = {
  __typename?: 'ContainerGraphql';
  documents: StoredDocumentCollection;
  id: Scalars['ID']['output'];
  material: MaterialGraphql;
  name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  site?: Maybe<SiteGraphql>;
  type?: Maybe<ContainerType>;
  unit?: Maybe<Scalars['String']['output']>;
};


export type ContainerGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export enum ContainerType {
  Ibc = 'IBC',
  Barrel = 'barrel',
  Bin = 'bin',
  Bulk = 'bulk',
  Dumpster = 'dumpster',
  Other = 'other',
  PalletBox = 'pallet_box'
}

export type CreateBsdInput = {
  collectId: Scalars['ID']['input'];
};

export type CreateCapabilityInputGraphql = {
  address?: InputMaybe<Scalars['String']['input']>;
  capCode?: InputMaybe<Scalars['String']['input']>;
  capExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outletName?: InputMaybe<Scalars['String']['input']>;
  siret?: InputMaybe<Scalars['String']['input']>;
  standardMaterialId: Scalars['ID']['input'];
  treatmentCode: Scalars['String']['input'];
};

export type CreateClientInput = {
  bic?: InputMaybe<Scalars['String']['input']>;
  clientAddress?: InputMaybe<ClientAddressInput>;
  firstName: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  paysMonthlyFees?: InputMaybe<Scalars['Float']['input']>;
  percentageRecyclerRevshare?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber: Scalars['String']['input'];
  siret: Scalars['String']['input'];
  transporterReceipt?: InputMaybe<Scalars['String']['input']>;
  type: ClientType;
};

export type CreateCollectContainerAttachmentInput = {
  /** The file name of the attachment (optional, defaults to last segment of uploadPath) */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** The upload path of the attachment */
  uploadPath: Scalars['String']['input'];
};

export type CreateCollectContainerItemGraphql = {
  containerId: Scalars['ID']['input'];
  files?: InputMaybe<Array<CreateCollectContainerAttachmentInput>>;
  materialId: Scalars['ID']['input'];
};

export type CreateCollectGraphql = {
  /** Admin only. Allows creating a collect for a given clientId */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  containers: Array<CreateCollectContainerItemGraphql>;
  endsAt: Scalars['DateTime']['input'];
  notes: Scalars['String']['input'];
  /** The user ID of the owner for this collect. */
  referentUserId: Scalars['ID']['input'];
  /** The site on which the collect should happen. */
  siteId: Scalars['ID']['input'];
  startsAt: Scalars['DateTime']['input'];
};

export type CreateInvoicedServiceInputGraphql = {
  description: Scalars['String']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  isRecurring: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  producerId: Scalars['ID']['input'];
  recyclerId: Scalars['ID']['input'];
  startsAt: Scalars['DateTime']['input'];
  value: Scalars['Float']['input'];
  vat: Scalars['Float']['input'];
};

export type CreateMaterialInputGraphql = {
  UNCode?: InputMaybe<Scalars['String']['input']>;
  capCode?: InputMaybe<Scalars['String']['input']>;
  capCodeExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  clientId: Scalars['ID']['input'];
  consistency: MaterialConsistence;
  isSold?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  recyclerId: Scalars['ID']['input'];
  standardMaterialId?: InputMaybe<Scalars['ID']['input']>;
  wasteCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationInput = {
  companyName: Scalars['String']['input'];
  companySiret: Scalars['String']['input'];
  inviteUser?: InputMaybe<CreateOrganizationInviteUserInput>;
  organizationName: Scalars['String']['input'];
  organizationType: OrganizationType;
  rootUserFirstName: Scalars['String']['input'];
  rootUserFunction: Scalars['String']['input'];
  rootUserLastName: Scalars['String']['input'];
  rootUserPhoneNumber: Scalars['String']['input'];
};

export type CreateOrganizationInviteUserInput = {
  email: Scalars['String']['input'];
  sendInvitationEmail: Scalars['Boolean']['input'];
};

export type CreatePricingInputGraphql = {
  endDate: Scalars['DateTime']['input'];
  makePricingActive?: InputMaybe<Scalars['Boolean']['input']>;
  materialId: Scalars['Float']['input'];
  price: Scalars['Float']['input'];
  producerId: Scalars['Float']['input'];
  recyclerId: Scalars['Float']['input'];
  startDate: Scalars['DateTime']['input'];
  status: PriceListStatus;
  type: PriceListType;
  unit: Scalars['String']['input'];
  vat: Scalars['Float']['input'];
};

export type CreateProducerRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isRecurring: Scalars['Boolean']['input'];
  materialName: Scalars['String']['input'];
  onSiteIdentificationRequests: Scalars['Boolean']['input'];
  producerId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  siteId: Scalars['ID']['input'];
  urgentRequest: Scalars['Boolean']['input'];
};

export type CreateUserInput = {
  clientId: Scalars['ID']['input'];
  disabled: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  function: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  role: UserRoles;
};

export type CreatedBsdGraphql = {
  __typename?: 'CreatedBSDGraphql';
  collectId: Scalars['ID']['output'];
};

export type CurrentUserGraphql = {
  __typename?: 'CurrentUserGraphql';
  client: ClientGraphql;
  entitlements: EntitlementsGraphql;
  organization: OrganizationGraphql;
  user: UserGraphql;
};

/** A treatment code that has been remapped via the configuration of the WP organization. */
export type CustomTreatmentCodeGraphql = TreatmentCodeGraphql & {
  __typename?: 'CustomTreatmentCodeGraphql';
  code: TreatmentCodeKey;
  customTreatmentKind?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  isRemapped?: Maybe<Scalars['Boolean']['output']>;
};

export type DeclareIncidentGraphqlInput = {
  collectId: Scalars['ID']['input'];
  collectedContainerId?: InputMaybe<Scalars['ID']['input']>;
  comment: Scalars['String']['input'];
  nonConformMaterialQuantity?: InputMaybe<Scalars['Float']['input']>;
  penaltyAmount: Scalars['Float']['input'];
  penaltyComment: Scalars['String']['input'];
  type: IncidentType;
};

export type DefaultPricingGraphql = MaterialPricingGraphql & {
  __typename?: 'DefaultPricingGraphql';
  correlationId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  details: MaterialPricingDetails;
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  recycler?: Maybe<ProducerGraphql>;
  shouldBeUpdatedAt: Scalars['DateTime']['output'];
  standardMaterial?: Maybe<StandardMaterialGraphql>;
  targetProducer?: Maybe<ProducerGraphql>;
  updateFrequency: FrequencyGraphql;
  vat: Scalars['Float']['output'];
};

export type DeleteCapabilityGraphql = {
  id: Scalars['ID']['input'];
};

export type DeleteContainerGraphql = {
  id: Scalars['ID']['input'];
};

export type DeleteDocumentTagInput = {
  id: Scalars['ID']['input'];
};

export type DeleteInvoicedServiceInputGraphql = {
  invoicedServiceId: Scalars['ID']['input'];
};

export type DeleteMaterialInputGraphql = {
  materialId: Scalars['ID']['input'];
};

export type DeleteStoredDocumentGraphqlInput = {
  clientId: Scalars['ID']['input'];
  id: Scalars['String']['input'];
};

export type DeleteUserInput = {
  id: Scalars['ID']['input'];
};

export enum DocumentContext {
  Client = 'CLIENT',
  Collect = 'COLLECT',
  CollectedContainer = 'COLLECTED_CONTAINER',
  Container = 'CONTAINER',
  Incident = 'INCIDENT',
  Material = 'MATERIAL',
  ProducerRequest = 'PRODUCER_REQUEST'
}

export type DocumentGraphql = {
  __typename?: 'DocumentGraphql';
  content: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum DocumentMetaSubtypes {
  IcpeInspectionReport = 'ICPE_inspection_report',
  IcpePrefecturalAuthorization = 'ICPE_prefectural_authorization',
  BrokerageReceipt = 'brokerage_receipt',
  Cap = 'cap',
  CinqoLegalInformation = 'cinqo_legal_information',
  Co2Report = 'co2_report',
  CompanyLogo = 'company_logo',
  CustomLabels = 'custom_labels',
  CustomReports = 'custom_reports',
  DestructionCertificate = 'destruction_certificate',
  Ecovadis = 'ecovadis',
  FactoryPlan = 'factory_plan',
  Fip = 'fip',
  GroupReportingEcovadis = 'group_reporting_ecovadis',
  IcpeDecree = 'icpe_decree',
  IncidentReport = 'incident_report',
  Invoice = 'invoice',
  Kbis = 'kbis',
  LabelDocuments = 'label_documents',
  LegacyInvoice = 'legacy_invoice',
  LiabilityInsuranceCertificate = 'liability_insurance_certificate',
  MaterialSheet = 'material_sheet',
  ProvidersContract = 'providers_contract',
  PurchaseOrder = 'purchase_order',
  SevenFlowsCertification = 'seven_flows_certification',
  SitePlan = 'site_plan',
  TdBsd = 'td_bsd',
  TemplatesEcovadisIso = 'templates_ecovadis_iso',
  ThirdPartyApprovals = 'third_party_approvals',
  TrackingSheet = 'tracking_sheet',
  TransportReceipt = 'transport_receipt',
  Turnover = 'turnover',
  Uncategorized = 'uncategorized',
  WasteReport = 'waste_report',
  WeightingTicket = 'weighting_ticket'
}

export type DocumentTagAddToDocumentInput = {
  documentId: Scalars['ID']['input'];
  tagIds: Array<Scalars['ID']['input']>;
};

export type DocumentTagCollection = {
  __typename?: 'DocumentTagCollection';
  collection: Array<Maybe<DocumentTagGraphql>>;
  count: Scalars['Float']['output'];
};

/** Filters by tags. */
export type DocumentTagFilter = {
  /** Filters by tag IDs with an 'or' operator */
  or?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DocumentTagFilters = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentTagGraphql = {
  __typename?: 'DocumentTagGraphql';
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documents: Array<StoredDocumentGraphql>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: OrganizationGraphql;
  updatedAt: Scalars['DateTime']['output'];
};

export type DocumentTagInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type DocumentTagRemoveFromDocumentInput = {
  documentId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

export enum DocumentType {
  Document = 'DOCUMENT',
  Picture = 'PICTURE'
}

export type EntitlementsGraphql = {
  __typename?: 'EntitlementsGraphql';
  companies?: Maybe<Array<LocationEntitlementGraphql>>;
  organisations?: Maybe<Array<LocationEntitlementGraphql>>;
  sites?: Maybe<Array<LocationEntitlementGraphql>>;
};

export type ExtractInvoiceDataInput = {
  documentId: Scalars['ID']['input'];
  /** Allows using a specific extractor name to extract the documents content rather than the default one. */
  extractorName?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureGraphql = {
  __typename?: 'FeatureGraphql';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FrequencyGraphql = {
  __typename?: 'FrequencyGraphql';
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type GenerateSignedUploadUrlInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type GenerateWasteRegisterInput = {
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
};

export type GeneratedSignedUploadUrl = {
  __typename?: 'GeneratedSignedUploadUrl';
  url: Scalars['String']['output'];
};

export type HealthcheckAppStatusGraphql = {
  __typename?: 'HealthcheckAppStatusGraphql';
  app: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusCode?: Maybe<Scalars['Float']['output']>;
};

export type HealthcheckStatusGraphql = {
  __typename?: 'HealthcheckStatusGraphql';
  apps: Array<HealthcheckAppStatusGraphql>;
  date: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type IncidentCollection = {
  __typename?: 'IncidentCollection';
  collection: Array<Maybe<IncidentGraphql>>;
  count: Scalars['Float']['output'];
};

export type IncidentDocumentGraphql = StoredDocumentGraphql & {
  __typename?: 'IncidentDocumentGraphql';
  client: ClientGraphql;
  createdAt: Scalars['DateTime']['output'];
  documentContentRaw?: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  externalReference: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  /** if provided by the user, the sub-category of document */
  subtype?: Maybe<DocumentMetaSubtypes>;
  tags: Array<Maybe<DocumentTagGraphql>>;
  type: DocumentType;
};

export type IncidentFiltersGraphql = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  collectedContainerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IncidentGraphql = {
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUser: UserGraphql;
  documents: StoredDocumentCollection;
  id: Scalars['ID']['output'];
  penaltyAmount?: Maybe<Scalars['Float']['output']>;
  penaltyComment?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  status: IncidentStatus;
  type: IncidentType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type IncidentGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export enum IncidentStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  New = 'NEW',
  Open = 'OPEN'
}

export enum IncidentType {
  AccessProblem = 'ACCESS_PROBLEM',
  MaterialNonConformity = 'MATERIAL_NON_CONFORMITY',
  MaterialUnavailability = 'MATERIAL_UNAVAILABILITY',
  Other = 'OTHER'
}

export type InviteRecyclerToProducerInputGraphql = {
  WRCompanyName: Scalars['String']['input'];
  WREmail: Scalars['String']['input'];
  WRSiret: Scalars['String']['input'];
  producerId: Scalars['ID']['input'];
};

export type InvoicedServiceCollection = {
  __typename?: 'InvoicedServiceCollection';
  collection: Array<Maybe<InvoicedServiceGraphql>>;
  count: Scalars['Float']['output'];
};

export type InvoicedServiceGraphql = {
  __typename?: 'InvoicedServiceGraphql';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isRecurring: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  producer: ProducerGraphql;
  recycler: RecyclerGraphql;
  startsAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
};

export type InvoicedServiceInputGraphql = {
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  invoicedServiceId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
};

export type InvoicedServicesGraphqlFilter = {
  /** Filters by both producer and recycler */
  clientId?: InputMaybe<Scalars['ID']['input']>;
};

export type LegacyDataImportInput = {
  forClientId: Scalars['ID']['input'];
  forceFullResync?: InputMaybe<Scalars['Boolean']['input']>;
  pageName: Scalars['String']['input'];
  spreadsheetURI: Scalars['String']['input'];
};

export type LocationEntitlementGraphql = {
  __typename?: 'LocationEntitlementGraphql';
  id?: Maybe<Scalars['ID']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type LogAsInput = {
  userId: Scalars['String']['input'];
};

export type LoggedAs = {
  __typename?: 'LoggedAs';
  userJWT: Scalars['String']['output'];
};

export type MaterialCollection = {
  __typename?: 'MaterialCollection';
  collection: Array<Maybe<MaterialGraphql>>;
  count: Scalars['Float']['output'];
};

/** The consistency of the material */
export enum MaterialConsistence {
  Doughy = 'DOUGHY',
  Gaseous = 'GASEOUS',
  Liquid = 'LIQUID',
  Solid = 'SOLID'
}

export type MaterialDocumentGraphql = StoredDocumentGraphql & {
  __typename?: 'MaterialDocumentGraphql';
  client: ClientGraphql;
  createdAt: Scalars['DateTime']['output'];
  documentContentRaw?: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  externalReference: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  /** if provided by the user, the sub-category of document */
  subtype?: Maybe<DocumentMetaSubtypes>;
  tags: Array<Maybe<DocumentTagGraphql>>;
  type: DocumentType;
};

export type MaterialFiltersGraphql = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasContainer?: InputMaybe<Scalars['Boolean']['input']>;
  hasStandardMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Also include archived materials */
  withArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaterialGraphql = {
  __typename?: 'MaterialGraphql';
  UNCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated use pricingForCurrentRecycler instead */
  activePricing?: Maybe<PricingGraphql>;
  capCode?: Maybe<Scalars['String']['output']>;
  capCodeExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  consistency: MaterialConsistence;
  container: Array<ContainerGraphql>;
  documents: StoredDocumentCollection;
  id: Scalars['ID']['output'];
  /** Has the material been removed and is no longer available */
  isArchived: Scalars['Boolean']['output'];
  isSold?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** @deprecated disabled, using new pricing system */
  previousPricings?: Maybe<PricingCollection>;
  /** @deprecated disabled, using new pricing system */
  price?: Maybe<Scalars['Float']['output']>;
  pricingForCurrentRecycler?: Maybe<MaterialPricingGraphql>;
  producer: ProducerGraphql;
  recycler?: Maybe<RecyclerGraphql>;
  standardMaterial: StandardMaterialGraphql;
  wasteCode?: Maybe<Scalars['String']['output']>;
};


export type MaterialGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type MaterialPricingCollection = {
  __typename?: 'MaterialPricingCollection';
  collection: Array<Maybe<MaterialPricingGraphql>>;
  count: Scalars['Float']['output'];
};

export type MaterialPricingDetails = {
  __typename?: 'MaterialPricingDetails';
  VATAmount: Scalars['Float']['output'];
  totalRevshareEugene?: Maybe<Scalars['Float']['output']>;
  totalWithVAT: Scalars['Float']['output'];
  totalWithoutVAT: Scalars['Float']['output'];
};

export type MaterialPricingGraphql = {
  correlationId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  details: MaterialPricingDetails;
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  recycler?: Maybe<ProducerGraphql>;
  shouldBeUpdatedAt: Scalars['DateTime']['output'];
  standardMaterial?: Maybe<StandardMaterialGraphql>;
  targetProducer?: Maybe<ProducerGraphql>;
  updateFrequency: FrequencyGraphql;
  vat: Scalars['Float']['output'];
};

export type MaterialPricingGraphqlFilters = {
  materialCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  materialSubcategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  producerId?: InputMaybe<Scalars['ID']['input']>;
  recyclerId?: InputMaybe<Scalars['ID']['input']>;
};

export type MaterialPricingPerMaterialCollection = {
  __typename?: 'MaterialPricingPerMaterialCollection';
  collection: Array<Maybe<MaterialPricingPerMaterialGraphql>>;
  count: Scalars['Float']['output'];
};

export type MaterialPricingPerMaterialGraphql = {
  __typename?: 'MaterialPricingPerMaterialGraphql';
  correlationId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  details: MaterialPricingDetails;
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  producerPricings: MaterialPricingCollection;
  recycler?: Maybe<ProducerGraphql>;
  shouldBeUpdatedAt: Scalars['DateTime']['output'];
  standardMaterial?: Maybe<StandardMaterialGraphql>;
  targetProducer?: Maybe<ProducerGraphql>;
  updateFrequency: FrequencyGraphql;
  vat: Scalars['Float']['output'];
};


export type MaterialPricingPerMaterialGraphqlProducerPricingsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type MaterialQuantity = {
  __typename?: 'MaterialQuantity';
  materialName?: Maybe<Scalars['String']['output']>;
  materialQuantity?: Maybe<Scalars['Float']['output']>;
};

export type MaterialUnavailableIncidentGraphql = IncidentGraphql & {
  __typename?: 'MaterialUnavailableIncidentGraphql';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUser: UserGraphql;
  documents: StoredDocumentCollection;
  id: Scalars['ID']['output'];
  penaltyAmount?: Maybe<Scalars['Float']['output']>;
  penaltyComment?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  status: IncidentStatus;
  type: IncidentType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MaterialUnavailableIncidentGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept CGU */
  acceptCGU: Scalars['Boolean']['output'];
  acceptInvitation: UserGraphql;
  acceptRecyclerInvoiceToProducerRequestAndCreateMaterial: RecyclerResponseGraphql;
  addCompliancePageData: Array<ComplianceNodeGraphql>;
  addInvoicedService: InvoicedServiceGraphql;
  addNewMaterialPricing: MaterialPricingGraphql;
  addProducersToRecycler: RecyclerGraphql;
  addRecyclerCapability: RecyclerCapabilityGraphql;
  addRecyclersToProducer: ProducerGraphql;
  addTagsToDocument: Scalars['Boolean']['output'];
  assignRoleToUser: AssignedRoleGraphql;
  cancelCollect: CollectGraphql;
  /** Provided that the user is authenticated to Trackdechets and that no BSD already exists for this collect, creates a BSD on Trackdechets */
  createBSDForCollect: CreatedBsdGraphql;
  /** ADMIN ONLY -- Creates a client */
  createClient: ClientGraphql;
  createCollect: CollectGraphql;
  createDocumentTag: DocumentTagGraphql;
  createMaterial: MaterialGraphql;
  createOrganization: OrganizationGraphql;
  createPricing: PricingGraphql;
  createProducerRequest: ProducerRequestGraphql;
  /** ADMIN ONLY -- Creates a user */
  createUser: UserGraphql;
  declareIncident: IncidentGraphql;
  deleteCapability: Scalars['Boolean']['output'];
  deleteContainer: Scalars['Boolean']['output'];
  deleteDocumentTag: Scalars['Boolean']['output'];
  deleteIncident: IncidentGraphql;
  deleteInvoicedService: InvoicedServiceGraphql;
  /** Admin-only -- Archive a material */
  deleteMaterial: MaterialGraphql;
  deleteStoredDocument: Scalars['Boolean']['output'];
  /** ADMIN ONLY -- Deletes a user */
  deleteUser: Scalars['Boolean']['output'];
  extractInvoiceData: StoredDocumentGraphql;
  generateSignedUploadUrl: GeneratedSignedUploadUrl;
  importLegacyDataSpreadsheet: Scalars['Boolean']['output'];
  importSpreadsheet: Scalars['Boolean']['output'];
  inviteRecycler: ProducerGraphql;
  /** Admin only. Enables user impersonation. */
  logAs?: Maybe<LoggedAs>;
  rateCollectNPS: CollectGraphql;
  removeProducersFromRecycler: RecyclerGraphql;
  removeRecyclersFromProducer: ProducerGraphql;
  removeRoleFromUser: Scalars['Boolean']['output'];
  removeTagFromDocument: Scalars['Boolean']['output'];
  respondToProducerRequest: RecyclerResponseGraphql;
  /** Admin only. Send a collect created email for a specific collect. */
  sendCollectCreatedEmail: Scalars['Boolean']['output'];
  /** Admin only. Send a collect missing informations reminder to WR for a specific collect. */
  sendCollectMissingInformationsReminder: Scalars['Boolean']['output'];
  sendProducerRequestToRecycler: ProducerRequestGraphql;
  /** Admin only. Allows setting for which materials the BSD creation is enabled */
  setEnabledMaterialsForBSDCreation: ProducerGraphql;
  /** @deprecated use signMultipleBSDs instead. */
  signAllCollectBSDs: Array<BsdGraphql>;
  /** @deprecated use signMultipleBSDs instead. */
  signBSDs: Array<BsdGraphql>;
  signMultipleBSDs: BsdCollection;
  /** Allows signing-up */
  signUp: ClientGraphql;
  /** Admin only. Soft deletes a company and all related entities */
  softDeleteCompany: Scalars['Boolean']['output'];
  storeDocumentReference: StoredDocumentGraphql;
  toggleTrackdechetsAutosign: ClientGraphql;
  updateClient: ClientGraphql;
  updateCollectInformations: CollectGraphql;
  updateCollectedContainer: CollectedContainerGraphql;
  updateIncident: IncidentGraphql;
  updateInvoicedService: InvoicedServiceGraphql;
  updateMaterial: MaterialGraphql;
  /** Update a Metabase dashboard by URL to enable client_id embedding */
  updateMetabaseDashboard: Scalars['Boolean']['output'];
  updateNotificationPreferences: UserGraphql;
  updateOrganizationConfiguration: OrganizationGraphql;
  /** ADMIN ONLY -- Updates a user */
  updateUser: UserGraphql;
  upsertContainer: ContainerGraphql;
  upsertSite: SiteGraphql;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAcceptRecyclerInvoiceToProducerRequestAndCreateMaterialArgs = {
  input: AcceptRecyclerInvoiceToProducerRequestAndCreateMaterialInput;
};


export type MutationAddCompliancePageDataArgs = {
  input: ComplianceNodeGraphqlInputList;
};


export type MutationAddInvoicedServiceArgs = {
  input: CreateInvoicedServiceInputGraphql;
};


export type MutationAddNewMaterialPricingArgs = {
  input: AddNewMaterialPricingGraphqlInput;
};


export type MutationAddProducersToRecyclerArgs = {
  input: ProducersToRecyclerInput;
};


export type MutationAddRecyclerCapabilityArgs = {
  input: CreateCapabilityInputGraphql;
};


export type MutationAddRecyclersToProducerArgs = {
  input: RecyclersToProducerInput;
};


export type MutationAddTagsToDocumentArgs = {
  input: DocumentTagAddToDocumentInput;
};


export type MutationAssignRoleToUserArgs = {
  input: AssignRoleInput;
};


export type MutationCancelCollectArgs = {
  input: CancelCollectInputGraphql;
};


export type MutationCreateBsdForCollectArgs = {
  input: CreateBsdInput;
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationCreateCollectArgs = {
  input: CreateCollectGraphql;
};


export type MutationCreateDocumentTagArgs = {
  input: DocumentTagInput;
};


export type MutationCreateMaterialArgs = {
  input: CreateMaterialInputGraphql;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreatePricingArgs = {
  input: CreatePricingInputGraphql;
};


export type MutationCreateProducerRequestArgs = {
  input: CreateProducerRequestInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeclareIncidentArgs = {
  input: DeclareIncidentGraphqlInput;
};


export type MutationDeleteCapabilityArgs = {
  input: DeleteCapabilityGraphql;
};


export type MutationDeleteContainerArgs = {
  input: DeleteContainerGraphql;
};


export type MutationDeleteDocumentTagArgs = {
  input: DeleteDocumentTagInput;
};


export type MutationDeleteIncidentArgs = {
  input: UpdateIncidentGraphqlInput;
};


export type MutationDeleteInvoicedServiceArgs = {
  input: DeleteInvoicedServiceInputGraphql;
};


export type MutationDeleteMaterialArgs = {
  input: DeleteMaterialInputGraphql;
};


export type MutationDeleteStoredDocumentArgs = {
  input: DeleteStoredDocumentGraphqlInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationExtractInvoiceDataArgs = {
  input: ExtractInvoiceDataInput;
};


export type MutationGenerateSignedUploadUrlArgs = {
  input: GenerateSignedUploadUrlInput;
};


export type MutationImportLegacyDataSpreadsheetArgs = {
  input: LegacyDataImportInput;
};


export type MutationInviteRecyclerArgs = {
  input: InviteRecyclerToProducerInputGraphql;
};


export type MutationLogAsArgs = {
  input: LogAsInput;
};


export type MutationRateCollectNpsArgs = {
  input: RateCollectNpsInputGraphql;
};


export type MutationRemoveProducersFromRecyclerArgs = {
  input: ProducersToRecyclerInput;
};


export type MutationRemoveRecyclersFromProducerArgs = {
  input: RecyclersToProducerInput;
};


export type MutationRemoveRoleFromUserArgs = {
  input: AssignRoleInput;
};


export type MutationRemoveTagFromDocumentArgs = {
  input: DocumentTagRemoveFromDocumentInput;
};


export type MutationRespondToProducerRequestArgs = {
  input: RecyclerResponseInput;
};


export type MutationSendCollectCreatedEmailArgs = {
  collectId: Scalars['String']['input'];
};


export type MutationSendCollectMissingInformationsReminderArgs = {
  collectId: Scalars['String']['input'];
};


export type MutationSendProducerRequestToRecyclerArgs = {
  input: SendProducerRequestToRecyclerInput;
};


export type MutationSetEnabledMaterialsForBsdCreationArgs = {
  input: SetEnabledMaterialsForBsdCreationInput;
};


export type MutationSignAllCollectBsDsArgs = {
  input: SignAllCollectBsDsInput;
};


export type MutationSignBsDsArgs = {
  input: SignBsdInput;
};


export type MutationSignMultipleBsDsArgs = {
  input: SignBsdInput;
};


export type MutationSignUpArgs = {
  input: SignUpInputGraphql;
};


export type MutationSoftDeleteCompanyArgs = {
  companyId: Scalars['Float']['input'];
};


export type MutationStoreDocumentReferenceArgs = {
  input: StoreDocumentReferenceInput;
};


export type MutationUpdateClientArgs = {
  input: ClientInput;
};


export type MutationUpdateCollectInformationsArgs = {
  input: UpdateCollectInformationsGraphql;
};


export type MutationUpdateCollectedContainerArgs = {
  input: UpdateCollectedContainerInput;
};


export type MutationUpdateIncidentArgs = {
  input: UpdateIncidentGraphqlInput;
};


export type MutationUpdateInvoicedServiceArgs = {
  input: InvoicedServiceInputGraphql;
};


export type MutationUpdateMaterialArgs = {
  input: UpdateMaterialInputGraphql;
};


export type MutationUpdateMetabaseDashboardArgs = {
  input: UpdateMetabaseDashboardInput;
};


export type MutationUpdateNotificationPreferencesArgs = {
  input: UpdateNotificationPreferencesInput;
};


export type MutationUpdateOrganizationConfigurationArgs = {
  input: UpdateOrganizationConfigurationInputGraphql;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpsertContainerArgs = {
  input: UpsertContainerGraphql;
};


export type MutationUpsertSiteArgs = {
  input: SiteInputGraphql;
};

export type NpsGraphql = {
  __typename?: 'NPSGraphql';
  additionalDetails?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Float']['output'];
};

export type NonConformityIncidentGraphql = IncidentGraphql & {
  __typename?: 'NonConformityIncidentGraphql';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUser: UserGraphql;
  documents: StoredDocumentCollection;
  id: Scalars['ID']['output'];
  nonConformMaterialQuantity?: Maybe<Scalars['Float']['output']>;
  penaltyAmount?: Maybe<Scalars['Float']['output']>;
  penaltyComment?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  status: IncidentStatus;
  type: IncidentType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type NonConformityIncidentGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type NotificationGraphql = {
  __typename?: 'NotificationGraphql';
  wpCollectUpdated?: Maybe<Scalars['String']['output']>;
  wpDocumentsReadyNotifiedAt?: Maybe<Scalars['String']['output']>;
  wrCollectConfirmedNotifiedAt?: Maybe<Scalars['String']['output']>;
  wrNotifiedAt?: Maybe<Scalars['String']['output']>;
};

export type NotificationPreferenceInput = {
  enabled: Scalars['Boolean']['input'];
  type: NotificationType;
};

export type NotificationPreferencesGraphql = {
  __typename?: 'NotificationPreferencesGraphql';
  enabled: Scalars['Boolean']['output'];
  type: NotificationType;
};

export enum NotificationType {
  CollectAssignedToWr = 'COLLECT_ASSIGNED_TO_WR',
  CollectConfirmedByWr = 'COLLECT_CONFIRMED_BY_WR',
  CollectCreatedByWp = 'COLLECT_CREATED_BY_WP',
  CollectDocumentsReady = 'COLLECT_DOCUMENTS_READY',
  CollectMissingInformationReminder = 'COLLECT_MISSING_INFORMATION_REMINDER',
  WpInviteWr = 'WP_INVITE_WR'
}

export type OrderByArgs = {
  field: Scalars['String']['input'];
  order: AscDescGraphql;
};

export type OrganizationCollection = {
  __typename?: 'OrganizationCollection';
  collection: Array<Maybe<OrganizationGraphql>>;
  count: Scalars['Float']['output'];
};

export type OrganizationFiltersGraphql = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hasCompaniesOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organizationTypes?: InputMaybe<Array<OrganizationType>>;
  /** Searches by organization name or companies names in organization */
  search?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OrganizationGraphql = {
  __typename?: 'OrganizationGraphql';
  companies: ClientCollection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  treatmentCodes?: Maybe<Array<TreatmentCodeGraphql>>;
  type: OrganizationType;
  users: UserCollection;
};


export type OrganizationGraphqlCompaniesArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};


export type OrganizationGraphqlUsersArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type OrganizationRole = RoleGraphql & {
  __typename?: 'OrganizationRole';
  features?: Maybe<Array<FeatureGraphql>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: OrganizationGraphql;
};

export enum OrganizationType {
  Cinqo = 'cinqo',
  Producer = 'producer',
  Recycler = 'recycler',
  Transporter = 'transporter',
  TransporterRecycler = 'transporter_recycler'
}

export type OtherIncidentGraphql = IncidentGraphql & {
  __typename?: 'OtherIncidentGraphql';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdByUser: UserGraphql;
  documents: StoredDocumentCollection;
  id: Scalars['ID']['output'];
  penaltyAmount?: Maybe<Scalars['Float']['output']>;
  penaltyComment?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  status: IncidentStatus;
  type: IncidentType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type OtherIncidentGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type PaginationArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
};

export type PartialUserCollection = {
  __typename?: 'PartialUserCollection';
  collection: Array<Maybe<PartialUserGraphql>>;
  count: Scalars['Float']['output'];
};

export type PartialUserGraphql = {
  __typename?: 'PartialUserGraphql';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type PriceListCollection = {
  __typename?: 'PriceListCollection';
  collection: Array<Maybe<PricingGraphql>>;
  count: Scalars['Float']['output'];
};

export enum PriceListStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum PriceListType {
  BinCollection = 'BIN_COLLECTION'
}

export type PricingCollection = {
  __typename?: 'PricingCollection';
  collection: Array<Maybe<PricingGraphql>>;
  count: Scalars['Float']['output'];
};

export type PricingFiltersGraphql = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  materialIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<PriceListStatus>;
};

export type PricingGraphql = {
  __typename?: 'PricingGraphql';
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  material: MaterialGraphql;
  price: Scalars['Float']['output'];
  producer: ProducerGraphql;
  startDate: Scalars['DateTime']['output'];
  status: PriceListStatus;
  unit: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vat: Scalars['Float']['output'];
};

export enum PricingSourceType {
  Manual = 'MANUAL'
}

export type PricingSummaryInputGraphql = {
  viewAsProducer: Scalars['Boolean']['input'];
};

export type ProducerCollection = {
  __typename?: 'ProducerCollection';
  collection: Array<Maybe<ProducerGraphql>>;
  count: Scalars['Float']['output'];
};

export type ProducerGraphql = ClientGraphql & {
  __typename?: 'ProducerGraphql';
  address?: Maybe<AddressGraphql>;
  autosignEnabledForTrackdechets: Scalars['Boolean']['output'];
  bic?: Maybe<Scalars['String']['output']>;
  bsdCreationEnabledForMaterials?: Maybe<TdOptionsMaterialTypes>;
  companyLogo?: Maybe<ClientDocumentGraphql>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  customDashboard?: Maybe<Scalars['String']['output']>;
  customDashboardId?: Maybe<Scalars['Float']['output']>;
  documents: StoredDocumentCollection;
  /** True if the client has collects either as a producer or a recycler */
  hasCollects: Scalars['Boolean']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isConnectedToTrackdechets?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  onboarding: CompanyOnboardingGraphql;
  onboardingDone?: Maybe<Scalars['Boolean']['output']>;
  onboardingNeeds?: Maybe<Scalars['String']['output']>;
  organization: OrganizationGraphql;
  paysMonthlyFees?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  recyclers: RecyclerCollection;
  siret?: Maybe<Scalars['String']['output']>;
  sites: SitesCollection;
  slug: Scalars['String']['output'];
  type: ClientType;
};


export type ProducerGraphqlCustomDashboardArgs = {
  input?: InputMaybe<ClientCustomDashboardInputGraphql>;
};


export type ProducerGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};


export type ProducerGraphqlOnboardingArgs = {
  filters?: InputMaybe<CompanyOnboardingInputGraphql>;
};


export type ProducerGraphqlRecyclersArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};


export type ProducerGraphqlSitesArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type ProducerRequestDocumentGraphql = StoredDocumentGraphql & {
  __typename?: 'ProducerRequestDocumentGraphql';
  client: ClientGraphql;
  createdAt: Scalars['DateTime']['output'];
  documentContentRaw?: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  externalReference: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  /** if provided by the user, the sub-category of document */
  subtype?: Maybe<DocumentMetaSubtypes>;
  tags: Array<Maybe<DocumentTagGraphql>>;
  type: DocumentType;
};

export type ProducerRequestFiltersGraphql = {
  companyId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Array<ProducerRequestStatus>>;
};

export type ProducerRequestGraphql = {
  __typename?: 'ProducerRequestGraphql';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents: StoredDocumentCollection;
  id: Scalars['ID']['output'];
  isRecurring: Scalars['Boolean']['output'];
  materialName: Scalars['String']['output'];
  onSiteIdentificationRequests: Scalars['Boolean']['output'];
  photo?: Maybe<StoredDocumentCollection>;
  producer: ClientGraphql;
  quantity?: Maybe<Scalars['Float']['output']>;
  responses: RecyclerResponsesCollection;
  site: SiteGraphql;
  status: ProducerRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
  urgentRequest: Scalars['Boolean']['output'];
  wasteCode?: Maybe<Scalars['String']['output']>;
};


export type ProducerRequestGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};


export type ProducerRequestGraphqlPhotoArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export enum ProducerRequestStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type ProducerRequestsCollection = {
  __typename?: 'ProducerRequestsCollection';
  collection: Array<Maybe<ProducerRequestGraphql>>;
  count: Scalars['Float']['output'];
};

export type ProducerWelcomeScreenGraphql = WelcomeScreenGraphql & {
  __typename?: 'ProducerWelcomeScreenGraphql';
  bsdToSign?: Maybe<Scalars['Float']['output']>;
  collectWithIncidents?: Maybe<Scalars['Float']['output']>;
  incomingCollects?: Maybe<Scalars['Float']['output']>;
};

export type ProducersToRecyclerInput = {
  producerIds: Array<Scalars['ID']['input']>;
  recyclerId: Scalars['ID']['input'];
};

export type Query = {
  __typename?: 'Query';
  BSDs: BsdCollectionGraphql;
  availableCategoriesAndSubcategories: Array<AvailableCategories>;
  clients: ClientCollection;
  co2Saved: Co2Saved;
  collectCSVExtract: CollectCsvExtractGraphql;
  collectDocuments: StoredDocumentCollection;
  collectedContainers: CollectedContainerCollection;
  /** The list of collects for the current user */
  collects: CollectsCollection;
  collectsThatNeedToBeSigned: Scalars['Float']['output'];
  collectsWithMissingFields: Array<CollectGraphql>;
  compliancePage: Array<ComplianceNodeGraphql>;
  compliancePageStructure: Array<ComplianceStructureNodeGraphql>;
  complianceScore: Array<ComplianceScoreGraphql>;
  containers: ContainerCollection;
  documentTags: DocumentTagCollection;
  documents: StoredDocumentCollection;
  generateWasteRegister: DocumentGraphql;
  getDashboardUrl?: Maybe<Scalars['String']['output']>;
  getWastePerMonthPerType?: Maybe<Array<WastePerMonthPerType>>;
  healthcheck: Scalars['String']['output'];
  healthcheckStatus: HealthcheckStatusGraphql;
  incidents: IncidentCollection;
  invoicedServices: InvoicedServiceCollection;
  materialPricings: MaterialPricingCollection;
  /**
   * Returns pricings per material without returning the producer pricings.
   * Only recyclers & admins can fetch pricings per material.
   */
  materialPricingsPerMaterial: MaterialPricingPerMaterialCollection;
  materials: MaterialCollection;
  me: CurrentUserGraphql;
  moneyPerMonthMetrics: Array<TotalMoneyPerMonth>;
  organizations: OrganizationCollection;
  pricingsv1: PriceListCollection;
  producerRequestsByClientId: ProducerRequestsCollection;
  recyclerCapabilities: RecyclerCapabilityCollection;
  recyclerResponsesByClientId: RecyclerResponsesCollection;
  /** Fetches the list of possible referent users for the collect creation. */
  referents: PartialUserCollection;
  roles: Array<RoleGraphql>;
  searchCompanies: Array<CompanySearchResultGraphql>;
  /** Will return degraded result as it is public. */
  searchCompaniesPublic: Array<CompanySearchResultGraphql>;
  sites: SitesCollection;
  standardMaterials: StandardMaterialCollection;
  tagsByDocument: DocumentTagCollection;
  testPermission: Scalars['Boolean']['output'];
  /** The default standard treatment codes. Can be customized at the organization level. */
  treatmentCodes: Array<TreatmentCodeGraphql>;
  /** ADMIN ONLY -- Fetches all users */
  users: UserCollection;
  wasteCodes: Array<WasteCodesGraphql>;
  welcomeScreen: WelcomeScreenGraphql;
};


export type QueryBsDsArgs = {
  filters: BsdFiltersGraphql;
};


export type QueryClientsArgs = {
  filters?: InputMaybe<ClientFilterGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryCollectCsvExtractArgs = {
  input: CollectCsvExtractInput;
};


export type QueryCollectDocumentsArgs = {
  filters?: InputMaybe<CollectDocumentFilters>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryCollectedContainersArgs = {
  filters?: InputMaybe<CollectedContainerGraphqlFilters>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryCollectsArgs = {
  filters?: InputMaybe<CollectGraphqlFilters>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryCollectsWithMissingFieldsArgs = {
  filters?: InputMaybe<CollectsWithMissingFieldsFiltersGraphql>;
};


export type QueryCompliancePageArgs = {
  filter?: InputMaybe<ComplianceNodeGraphqlFilter>;
};


export type QueryComplianceScoreArgs = {
  filter: ComplianceScoreGraphqlFilter;
};


export type QueryContainersArgs = {
  filters?: InputMaybe<ContainerFiltersGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryDocumentTagsArgs = {
  filters?: InputMaybe<DocumentTagFilters>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryDocumentsArgs = {
  filters: StoredDocumentFilters;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryGenerateWasteRegisterArgs = {
  input: GenerateWasteRegisterInput;
};


export type QueryGetDashboardUrlArgs = {
  input?: InputMaybe<ClientCustomDashboardInputGraphql>;
};


export type QueryIncidentsArgs = {
  filters?: InputMaybe<IncidentFiltersGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryInvoicedServicesArgs = {
  filters: InvoicedServicesGraphqlFilter;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryMaterialPricingsArgs = {
  filters: MaterialPricingGraphqlFilters;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryMaterialPricingsPerMaterialArgs = {
  filters: MaterialPricingGraphqlFilters;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryMaterialsArgs = {
  filters?: InputMaybe<MaterialFiltersGraphql>;
  orderBy?: InputMaybe<OrderByArgs>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryOrganizationsArgs = {
  filters?: InputMaybe<OrganizationFiltersGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryPricingsv1Args = {
  filters: PricingFiltersGraphql;
};


export type QueryProducerRequestsByClientIdArgs = {
  filters?: InputMaybe<ProducerRequestFiltersGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryRecyclerCapabilitiesArgs = {
  filters: RecyclerCapabilityGraphqlFilter;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryRecyclerResponsesByClientIdArgs = {
  filters?: InputMaybe<RecyclerResponseFiltersGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryRolesArgs = {
  filters?: InputMaybe<RolesInputGraphql>;
};


export type QuerySearchCompaniesArgs = {
  filters: SearchCompanyFilters;
};


export type QuerySearchCompaniesPublicArgs = {
  filters: SearchCompanyFilters;
};


export type QuerySitesArgs = {
  filters?: InputMaybe<SitesFilterGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryStandardMaterialsArgs = {
  filters: StandardMaterialFilters;
};


export type QueryTagsByDocumentArgs = {
  input: TagsByDocumentInput;
};


export type QueryUsersArgs = {
  filters?: InputMaybe<UserFilterGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
};

export type RateCollectNpsInputGraphql = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  collectId: Scalars['ID']['input'];
  rating: Scalars['Float']['input'];
};

export type RecyclerCapabilityCollection = {
  __typename?: 'RecyclerCapabilityCollection';
  collection: Array<Maybe<RecyclerCapabilityGraphql>>;
  count: Scalars['Float']['output'];
};

export type RecyclerCapabilityGraphql = {
  __typename?: 'RecyclerCapabilityGraphql';
  capCode?: Maybe<Scalars['String']['output']>;
  capExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  client: RecyclerGraphql;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  outlet: RecyclerGraphql;
  outletName?: Maybe<Scalars['String']['output']>;
  standardMaterial: StandardMaterialGraphql;
  treatmentCode: Scalars['String']['output'];
};

export type RecyclerCapabilityGraphqlFilter = {
  /** Admin only. */
  clientId?: InputMaybe<Scalars['ID']['input']>;
};

export type RecyclerCollection = {
  __typename?: 'RecyclerCollection';
  collection: Array<Maybe<RecyclerGraphql>>;
  count: Scalars['Float']['output'];
};

export type RecyclerGraphql = ClientGraphql & {
  __typename?: 'RecyclerGraphql';
  address?: Maybe<AddressGraphql>;
  autosignEnabledForTrackdechets: Scalars['Boolean']['output'];
  bic?: Maybe<Scalars['String']['output']>;
  companyLogo?: Maybe<ClientDocumentGraphql>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  customDashboard?: Maybe<Scalars['String']['output']>;
  customDashboardId?: Maybe<Scalars['Float']['output']>;
  documents: StoredDocumentCollection;
  /** True if the client has collects either as a producer or a recycler */
  hasCollects: Scalars['Boolean']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isConnectedToTrackdechets?: Maybe<Scalars['Boolean']['output']>;
  isPremiumRecycler?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  onboardingDone?: Maybe<Scalars['Boolean']['output']>;
  onboardingNeeds?: Maybe<Scalars['String']['output']>;
  organization: OrganizationGraphql;
  paysMonthlyFees?: Maybe<Scalars['Float']['output']>;
  percentageRecyclerRevshare?: Maybe<Scalars['Float']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  producers: ProducerCollection;
  siret?: Maybe<Scalars['String']['output']>;
  sites: SitesCollection;
  slug: Scalars['String']['output'];
  transporterReceipt?: Maybe<Scalars['String']['output']>;
  type: ClientType;
};


export type RecyclerGraphqlCustomDashboardArgs = {
  input?: InputMaybe<ClientCustomDashboardInputGraphql>;
};


export type RecyclerGraphqlDocumentsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};


export type RecyclerGraphqlProducersArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};


export type RecyclerGraphqlSitesArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type RecyclerResponseFiltersGraphql = {
  companyId?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<Array<RecyclerResponseStatus>>;
};

export type RecyclerResponseGraphql = {
  __typename?: 'RecyclerResponseGraphql';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  client: ClientGraphql;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  request: ProducerRequestGraphql;
  status: RecyclerResponseStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type RecyclerResponseInput = {
  accepted?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  requestId: Scalars['String']['input'];
  wasteCode?: InputMaybe<Scalars['String']['input']>;
};

export enum RecyclerResponseStatus {
  AcceptationPending = 'ACCEPTATION_PENDING',
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type RecyclerResponsesCollection = {
  __typename?: 'RecyclerResponsesCollection';
  collection: Array<Maybe<RecyclerResponseGraphql>>;
  count: Scalars['Float']['output'];
};

export type RecyclerWelcomeScreenGraphql = WelcomeScreenGraphql & {
  __typename?: 'RecyclerWelcomeScreenGraphql';
  bsdToSign?: Maybe<Scalars['Float']['output']>;
  collectsWithMissingFields?: Maybe<Scalars['Float']['output']>;
  incomingCollects?: Maybe<Scalars['Float']['output']>;
  materialPriceToUpdate?: Maybe<Scalars['Float']['output']>;
  materialWithoutPrice?: Maybe<Scalars['Float']['output']>;
};

export type RecyclersToProducerInput = {
  producerId: Scalars['ID']['input'];
  recyclerIds: Array<Scalars['ID']['input']>;
};

/** The non-custon standardized treatment codes of Cinqo. */
export type RegularTreatmentCodeGraphql = TreatmentCodeGraphql & {
  __typename?: 'RegularTreatmentCodeGraphql';
  code: TreatmentCodeKey;
  description: Scalars['String']['output'];
  isRemapped?: Maybe<Scalars['Boolean']['output']>;
  treatmentKind?: Maybe<TreatmentName>;
};

export type RoleGraphql = {
  features?: Maybe<Array<FeatureGraphql>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RolesInputGraphql = {
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Rubric = {
  __typename?: 'Rubric';
  activite?: Maybe<Scalars['String']['output']>;
  alinea?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  etatActivite?: Maybe<Scalars['String']['output']>;
  regimeAutorise?: Maybe<Scalars['String']['output']>;
  rubrique: Scalars['String']['output'];
  unite?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['String']['output']>;
  wasteType?: Maybe<Scalars['String']['output']>;
};

export type SearchCompanyFilters = {
  clue: Scalars['String']['input'];
  department?: InputMaybe<Scalars['String']['input']>;
};

export type SendProducerRequestToRecyclerInput = {
  recyclerIds: Array<Scalars['Float']['input']>;
  requestId: Scalars['String']['input'];
};

export type SetEnabledMaterialsForBsdCreationInput = {
  bsdCreationEnabledForMaterials: TdOptionsMaterialTypes;
  producerId: Scalars['ID']['input'];
};

/** deprecated */
export type SignAllCollectBsDsInput = {
  collectId: Scalars['ID']['input'];
  signatureCode?: InputMaybe<Scalars['Float']['input']>;
};

export type SignBsdInput = {
  /** No effect for non-admin users. Allows signing a BSD in-lieu of another organization type. */
  as?: InputMaybe<OrganizationType>;
  bsdIds: Array<Scalars['ID']['input']>;
  collectId?: InputMaybe<Scalars['ID']['input']>;
};

export type SignUpInputGraphql = {
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  function?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  onboardingNeeds?: InputMaybe<Array<Scalars['String']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  siret: Scalars['String']['input'];
  type: ClientType;
  userId: Scalars['String']['input'];
};

export type SiteGraphql = {
  __typename?: 'SiteGraphql';
  address?: Maybe<Scalars['String']['output']>;
  client: ClientGraphql;
  collectsInformations?: Maybe<Scalars['String']['output']>;
  containers: ContainerCollection;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  openingHours?: Maybe<SiteOpeningHoursGraphql>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type SiteInputGraphql = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  collectsInformations?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** MUST pass all the opening hours at the same time. Will erase the previous ones with the new ones. */
  openingHours?: InputMaybe<SiteOpeningHoursInputGraphql>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type SiteOpeningHourGraphql = {
  __typename?: 'SiteOpeningHourGraphql';
  /** Format 00:00-23:59 */
  close: Scalars['String']['output'];
  /** Format 00:00-23:59 */
  open: Scalars['String']['output'];
};

export type SiteOpeningHourInputGraphql = {
  /** Format 00:00-23:59 */
  close: Scalars['String']['input'];
  /** Format 00:00-23:59 */
  open: Scalars['String']['input'];
};

export type SiteOpeningHoursGraphql = {
  __typename?: 'SiteOpeningHoursGraphql';
  friday?: Maybe<Array<SiteOpeningHourGraphql>>;
  monday?: Maybe<Array<SiteOpeningHourGraphql>>;
  saturday?: Maybe<Array<SiteOpeningHourGraphql>>;
  sunday?: Maybe<Array<SiteOpeningHourGraphql>>;
  thursday?: Maybe<Array<SiteOpeningHourGraphql>>;
  tuesday?: Maybe<Array<SiteOpeningHourGraphql>>;
  wednesday?: Maybe<Array<SiteOpeningHourGraphql>>;
};

export type SiteOpeningHoursInputGraphql = {
  friday?: InputMaybe<Array<SiteOpeningHourInputGraphql>>;
  monday?: InputMaybe<Array<SiteOpeningHourInputGraphql>>;
  saturday?: InputMaybe<Array<SiteOpeningHourInputGraphql>>;
  sunday?: InputMaybe<Array<SiteOpeningHourInputGraphql>>;
  thursday?: InputMaybe<Array<SiteOpeningHourInputGraphql>>;
  tuesday?: InputMaybe<Array<SiteOpeningHourInputGraphql>>;
  wednesday?: InputMaybe<Array<SiteOpeningHourInputGraphql>>;
};

export type SiteRole = RoleGraphql & {
  __typename?: 'SiteRole';
  features?: Maybe<Array<FeatureGraphql>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  site: SiteGraphql;
};

export type SitesCollection = {
  __typename?: 'SitesCollection';
  collection: Array<Maybe<SiteGraphql>>;
  count: Scalars['Float']['output'];
};

export type SitesFilterGraphql = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  siteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type StandardMaterialCollection = {
  __typename?: 'StandardMaterialCollection';
  collection: Array<Maybe<StandardMaterialGraphql>>;
  count: Scalars['Float']['output'];
};

export type StandardMaterialFilters = {
  search: Scalars['String']['input'];
};

export type StandardMaterialGraphql = {
  __typename?: 'StandardMaterialGraphql';
  attributes: Scalars['String']['output'];
  category: Scalars['String']['output'];
  consistency: MaterialConsistence;
  id: Scalars['ID']['output'];
  isDangerous: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pricings?: Maybe<MaterialPricingCollection>;
  reference: Scalars['String']['output'];
  shape: Scalars['String']['output'];
  subCategory: Scalars['String']['output'];
};


export type StandardMaterialGraphqlPricingsArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

export type StoreDocumentReferenceInput = {
  /** Allows an admin to upload a document to a specific client */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  /** The other object this document relates to. */
  externalReference: DocumentContext;
  /** the name of the file with its extension */
  fileName: Scalars['String']['input'];
  /** Only for onboarding documents */
  onboardingDocument?: InputMaybe<Scalars['Boolean']['input']>;
  /** the unique ID of the object referenced in the externalReference */
  referenceObjectId?: InputMaybe<Scalars['ID']['input']>;
  /** Only for a collect document. The subtype of the document */
  subtype?: InputMaybe<DocumentMetaSubtypes>;
  type: DocumentType;
};

export type StoredDocumentCollection = {
  __typename?: 'StoredDocumentCollection';
  collection: Array<Maybe<StoredDocumentGraphql>>;
  count: Scalars['Float']['output'];
};

export type StoredDocumentFilters = {
  contexts?: InputMaybe<Array<DocumentContext>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  onboardingDocument?: InputMaybe<Scalars['Boolean']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Only for a collect document. The subtype of the document */
  subtypes?: InputMaybe<Array<DocumentMetaSubtypes>>;
  tagFilter?: InputMaybe<DocumentTagFilter>;
  type?: InputMaybe<Array<DocumentType>>;
};

export type StoredDocumentGraphql = {
  client: ClientGraphql;
  createdAt: Scalars['DateTime']['output'];
  documentContentRaw?: Maybe<Scalars['String']['output']>;
  extension: Scalars['String']['output'];
  externalReference: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  /** if provided by the user, the sub-category of document */
  subtype?: Maybe<DocumentMetaSubtypes>;
  tags: Array<Maybe<DocumentTagGraphql>>;
  type: DocumentType;
};

export enum TdOptionsMaterialTypes {
  All = 'ALL',
  Dangerous = 'DANGEROUS',
  None = 'NONE',
  NonDangerous = 'NON_DANGEROUS'
}

export type TagsByDocumentInput = {
  documentId: Scalars['ID']['input'];
};

export type TotalMoneyPerMonth = {
  __typename?: 'TotalMoneyPerMonth';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
  totalsMetric: TotalsMetric;
};

export type TotalsMetric = {
  __typename?: 'TotalsMetric';
  totalIncidents: Scalars['Float']['output'];
  /** @deprecated Use totalMaterialsEarnings and totalMaterialsCosts instead */
  totalMaterials?: Maybe<Scalars['Float']['output']>;
  totalMaterialsCosts: Scalars['Float']['output'];
  totalMaterialsEarnings: Scalars['Float']['output'];
  totalTransport: Scalars['Float']['output'];
};

export enum TrackdechetsBsdState {
  Accepted = 'ACCEPTED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  NotCreated = 'NOT_CREATED',
  Processed = 'PROCESSED',
  Received = 'RECEIVED',
  Sealed = 'SEALED',
  Sent = 'SENT',
  SignedByProducer = 'SIGNED_BY_PRODUCER'
}

export type TransporterReceipt = {
  __typename?: 'TransporterReceipt';
  department: Scalars['String']['output'];
  id: Scalars['String']['output'];
  receiptNumber: Scalars['String']['output'];
  validityLimit: Scalars['DateTime']['output'];
};

export type TransporterReceiptGraphql = {
  __typename?: 'TransporterReceiptGraphql';
  department?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  receiptNumber?: Maybe<Scalars['String']['output']>;
};

export type TreatmentCodeGraphql = {
  code: TreatmentCodeKey;
  description: Scalars['String']['output'];
  isRemapped?: Maybe<Scalars['Boolean']['output']>;
};

export enum TreatmentCodeKey {
  D1 = 'D1',
  D2 = 'D2',
  D3 = 'D3',
  D4 = 'D4',
  D5 = 'D5',
  D6 = 'D6',
  D7 = 'D7',
  D8 = 'D8',
  D9 = 'D9',
  D9F = 'D9F',
  D10 = 'D10',
  D11 = 'D11',
  D12 = 'D12',
  D13 = 'D13',
  D14 = 'D14',
  D15 = 'D15',
  R0 = 'R0',
  R1 = 'R1',
  R2 = 'R2',
  R3 = 'R3',
  R4 = 'R4',
  R5 = 'R5',
  R6 = 'R6',
  R7 = 'R7',
  R8 = 'R8',
  R9 = 'R9',
  R10 = 'R10',
  R11 = 'R11',
  R12 = 'R12',
  R13 = 'R13'
}

export type TreatmentCodeMappingInputGraphql = {
  category: Scalars['String']['input'];
  code: TreatmentCodeKey;
  label: Scalars['String']['input'];
};

export enum TreatmentName {
  Elimination = 'ELIMINATION',
  None = 'NONE',
  Recyclage = 'RECYCLAGE',
  Reutilisation = 'REUTILISATION',
  ValorisationEnergetique = 'VALORISATION_ENERGETIQUE'
}

export type UpdateCollectInformationsGraphql = {
  co2Amount?: InputMaybe<Scalars['Float']['input']>;
  collectId: Scalars['ID']['input'];
  collectionPrice?: InputMaybe<Scalars['Float']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  referentId?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CollectStatus>;
  transportPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCollectedContainerInput = {
  collectedContainerId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  treatmentCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFrequencyGraphql = {
  unit: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type UpdateIncidentGraphqlInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  incidentId: Scalars['ID']['input'];
  nonConformMaterialQuantity?: InputMaybe<Scalars['Float']['input']>;
  penaltyAmount?: InputMaybe<Scalars['Float']['input']>;
  penaltyComment?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<IncidentStatus>;
  type?: InputMaybe<IncidentType>;
};

export type UpdateMaterialInputGraphql = {
  UNCode?: InputMaybe<Scalars['String']['input']>;
  capCode?: InputMaybe<Scalars['String']['input']>;
  capCodeExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  consistency?: InputMaybe<MaterialConsistence>;
  isSold?: InputMaybe<Scalars['Boolean']['input']>;
  materialId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  recyclerId?: InputMaybe<Scalars['ID']['input']>;
  standardMaterialId?: InputMaybe<Scalars['ID']['input']>;
  wasteCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMetabaseDashboardInput = {
  /** The client ID to associate with this dashboard */
  companyId: Scalars['ID']['input'];
  /** The Metabase dashboard URL to update */
  url: Scalars['String']['input'];
};

export type UpdateNotificationPreferencesInput = {
  preferences: Array<NotificationPreferenceInput>;
};

export type UpdateOrganizationConfigurationInputGraphql = {
  organizationId: Scalars['ID']['input'];
  treatmentCodeRemapping: Array<TreatmentCodeMappingInputGraphql>;
};

export type UpdateUserInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoles>;
};

export type UpsertContainerGraphql = {
  clientId: Scalars['ID']['input'];
  containerType: ContainerType;
  id?: InputMaybe<Scalars['ID']['input']>;
  materialId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  siteId: Scalars['ID']['input'];
  unit?: Scalars['String']['input'];
};

export type UserCollection = {
  __typename?: 'UserCollection';
  collection: Array<Maybe<UserGraphql>>;
  count: Scalars['Float']['output'];
};

export type UserFilterGraphql = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Searches all users using text. Overrides all other parameters. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type UserGraphql = {
  __typename?: 'UserGraphql';
  acceptedInvitation: Scalars['Boolean']['output'];
  acceptedTermsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The currently assigned roles to the user. */
  assignedRoles: AssignedRolesCollection;
  client: ClientGraphql;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Will sometimes be not provided depending on context as we consider this field to be confidential. */
  email?: Maybe<Scalars['String']['output']>;
  /** Given the user current roles, what the user is entitled to access. */
  entitlements: EntitlementsGraphql;
  firstName?: Maybe<Scalars['String']['output']>;
  function?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<UserPreferencesGraphql>;
  role: UserRoles;
};

export type UserPreferencesGraphql = {
  __typename?: 'UserPreferencesGraphql';
  notificationPreferences: Array<Maybe<NotificationPreferencesGraphql>>;
};

export enum UserRoles {
  AdminApp = 'admin_app',
  User = 'user'
}

export type WpSpecificPricingGraphql = MaterialPricingGraphql & {
  __typename?: 'WPSpecificPricingGraphql';
  correlationId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  details: MaterialPricingDetails;
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  recycler?: Maybe<ProducerGraphql>;
  shouldBeUpdatedAt: Scalars['DateTime']['output'];
  standardMaterial?: Maybe<StandardMaterialGraphql>;
  targetProducer?: Maybe<ProducerGraphql>;
  updateFrequency: FrequencyGraphql;
  vat: Scalars['Float']['output'];
};

export type WasteCodeGraphql = {
  __typename?: 'WasteCodeGraphql';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type WasteCodeSubCategoryGraphql = {
  __typename?: 'WasteCodeSubCategoryGraphql';
  codes: Array<WasteCodeGraphql>;
  subCategoryCode: Scalars['String']['output'];
  subCategoryDescription: Scalars['String']['output'];
};

export type WasteCodesGraphql = {
  __typename?: 'WasteCodesGraphql';
  categoryCode: Scalars['String']['output'];
  categoryDescription: Scalars['String']['output'];
  subCategories: Array<WasteCodeSubCategoryGraphql>;
};

export type WastePerMonthPerType = {
  __typename?: 'WastePerMonthPerType';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
  totalQuantityInMonth: Array<MaterialQuantity>;
  unit: Scalars['String']['output'];
};

export type WelcomeScreenGraphql = {
  bsdToSign?: Maybe<Scalars['Float']['output']>;
  incomingCollects?: Maybe<Scalars['Float']['output']>;
};

export type BsDsQueryVariables = Exact<{
  filters: BsdFiltersGraphql;
}>;


export type BsDsQuery = { __typename?: 'Query', BSDs: { __typename?: 'BSDCollectionGraphql', count: number, collection: Array<{ __typename?: 'BSDGraphql', tdState: TrackdechetsBsdState, publicState: CollectBsdState, id: string, errors: string, TDViewBSDUri?: string | null, collectedContainers: Array<{ __typename?: 'CollectedContainerGraphql', id: string, quantity?: number | null, treatmentCode?: string | null, container?: { __typename?: 'ContainerGraphql', name?: string | null, id: string } | null, material?: { __typename?: 'MaterialGraphql', id: string, name: string } | null }> } | null> } };

export type BsdByCollectIdQueryVariables = Exact<{
  pagination: PaginationArgs;
  filters?: InputMaybe<CollectGraphqlFilters>;
}>;


export type BsdByCollectIdQuery = { __typename?: 'Query', collects: { __typename?: 'CollectsCollection', collection: Array<{ __typename?: 'CollectGraphql', id: string, licensePlate?: string | null, endsAt?: any | null, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string }, recycler?: { __typename?: 'RecyclerGraphql', id: string, name: string } | null, BSDs: { __typename: 'BSDCollection', count: number, collection: Array<{ __typename: 'BSDGraphql', id: string, tdState: TrackdechetsBsdState, publicState: CollectBsdState, errors: string, TDViewBSDUri?: string | null, collectedContainers: Array<{ __typename?: 'CollectedContainerGraphql', id: string, quantity?: number | null, treatmentCode?: string | null, unit?: string | null, material?: { __typename?: 'MaterialGraphql', id: string, name: string } | null, container?: { __typename?: 'ContainerGraphql', name?: string | null, id: string } | null }> } | null> } } | null> } };

export type BsdByIdQueryVariables = Exact<{
  filters: BsdFiltersGraphql;
}>;


export type BsdByIdQuery = { __typename?: 'Query', BSDs: { __typename?: 'BSDCollectionGraphql', collection: Array<{ __typename?: 'BSDGraphql', downloadURI?: string | null } | null> } };

export type BsdOnCollectQueryVariables = Exact<{
  pagination: PaginationArgs;
  filters?: InputMaybe<CollectGraphqlFilters>;
  isAdmin: Scalars['Boolean']['input'];
}>;


export type BsdOnCollectQuery = { __typename?: 'Query', collects: { __typename?: 'CollectsCollection', count: number, collection: Array<{ __typename?: 'CollectGraphql', licensePlate?: string | null, endsAt?: any | null, id: string, client: { __typename?: 'ProducerGraphql', name: string, id: string } | { __typename?: 'RecyclerGraphql', name: string, id: string }, recycler?: { __typename?: 'RecyclerGraphql', id: string, name: string } | null, BSDs: { __typename: 'BSDCollection', count: number, collection: Array<{ __typename: 'BSDGraphql', id: string, tdState: TrackdechetsBsdState, publicState: CollectBsdState, errors: string, TDViewBSDUri?: string | null, collectedContainers: Array<{ __typename?: 'CollectedContainerGraphql', id: string, quantity?: number | null, treatmentCode?: string | null, unit?: string | null, material?: { __typename?: 'MaterialGraphql', id: string, name: string } | null, container?: { __typename?: 'ContainerGraphql', name?: string | null, id: string } | null }> } | null> }, isInvoiceable: { __typename?: 'CollectInvoiceGraphql', errors: Array<string | null>, alreadyInvoiced: boolean, result: boolean } } | null> } };

export type CreateBsdForCollectMutationVariables = Exact<{
  input: CreateBsdInput;
}>;


export type CreateBsdForCollectMutation = { __typename?: 'Mutation', createBSDForCollect: { __typename?: 'CreatedBSDGraphql', collectId: string } };

export type MutationMutationVariables = Exact<{
  input: SetEnabledMaterialsForBsdCreationInput;
}>;


export type MutationMutation = { __typename?: 'Mutation', setEnabledMaterialsForBSDCreation: { __typename?: 'ProducerGraphql', id: string, organization: { __typename?: 'OrganizationGraphql', id: string } } };

export type SignMultipleBsDsMutationVariables = Exact<{
  input: SignBsdInput;
}>;


export type SignMultipleBsDsMutation = { __typename?: 'Mutation', signMultipleBSDs: { __typename?: 'BSDCollection', collection: Array<{ __typename?: 'BSDGraphql', id: string, publicState: CollectBsdState, tdState: TrackdechetsBsdState } | null> } };

export type BsdDownloadUriQueryVariables = Exact<{
  filters: BsdFiltersGraphql;
}>;


export type BsdDownloadUriQuery = { __typename?: 'Query', BSDs: { __typename?: 'BSDCollectionGraphql', collection: Array<{ __typename?: 'BSDGraphql', downloadURI?: string | null } | null> } };

export type CollectsWithMissingFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollectsWithMissingFieldsQuery = { __typename?: 'Query', collectsWithMissingFields: Array<{ __typename?: 'CollectGraphql', licensePlate?: string | null, createdAt: any, id: string, startsAt?: any | null, endsAt?: any | null, collectedContainers: { __typename?: 'CollectedContainerCollection', collection: Array<{ __typename?: 'CollectedContainerGraphql', quantity?: number | null, unit?: string | null, id: string, treatmentCode?: string | null, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, signedUrl: string } | null> }, container?: { __typename?: 'ContainerGraphql', id: string, name?: string | null, material: { __typename?: 'MaterialGraphql', id: string, name: string } } | null } | null> }, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } }> };

export type IncomingCollectsQueryVariables = Exact<{
  pagination: PaginationArgs;
  filters?: InputMaybe<CollectGraphqlFilters>;
}>;


export type IncomingCollectsQuery = { __typename?: 'Query', collects: { __typename?: 'CollectsCollection', count: number, collection: Array<{ __typename?: 'CollectGraphql', status: CollectStatus, id: string, startsAt?: any | null } | null> } };

export type SendCollectMissingInformationsReminderMutationVariables = Exact<{
  collectId: Scalars['String']['input'];
}>;


export type SendCollectMissingInformationsReminderMutation = { __typename?: 'Mutation', sendCollectMissingInformationsReminder: boolean };

export type CollectedContainersByCollectIdQueryVariables = Exact<{
  filters?: InputMaybe<CollectedContainerGraphqlFilters>;
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type CollectedContainersByCollectIdQuery = { __typename?: 'Query', collectedContainers: { __typename?: 'CollectedContainerCollection', collection: Array<{ __typename?: 'CollectedContainerGraphql', id: string, quantity?: number | null, treatmentCode?: string | null, unit?: string | null, collect: { __typename?: 'CollectGraphql', client: { __typename?: 'ProducerGraphql', name: string, id: string } | { __typename?: 'RecyclerGraphql', name: string, id: string } }, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'CollectedContainerDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, id: string } | null> }, container?: { __typename?: 'ContainerGraphql', id: string, name?: string | null } | null } | null> } };

export type ComplianceScoreQueryVariables = Exact<{
  filter: ComplianceScoreGraphqlFilter;
}>;


export type ComplianceScoreQuery = { __typename?: 'Query', complianceScore: Array<{ __typename?: 'ComplianceScoreGraphql', category: string, completedRequired: number, score: number, totalRequired: number }> };

export type ContainerLabelsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArgs>;
  filters?: InputMaybe<ContainerFiltersGraphql>;
}>;


export type ContainerLabelsQuery = { __typename?: 'Query', containers: { __typename?: 'ContainerCollection', count: number, collection: Array<{ __typename?: 'ContainerGraphql', name?: string | null, quantity?: number | null, type?: ContainerType | null, unit?: string | null, id: string, material: { __typename?: 'MaterialGraphql', id: string, name: string, wasteCode?: string | null, UNCode?: string | null, capCodeExpiresAt?: any | null, capCode?: string | null, consistency: MaterialConsistence, standardMaterial: { __typename?: 'StandardMaterialGraphql', id: string, name: string, isDangerous: boolean }, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'CollectDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'ContainerDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'IncidentDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'MaterialDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, signedUrl: string, name: string } | null> } } } | null> } };

export type CurrentUserCompanyLogoQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserCompanyLogoQuery = { __typename?: 'Query', me: { __typename?: 'CurrentUserGraphql', client: { __typename?: 'ProducerGraphql', companyLogo?: { __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | null } | { __typename?: 'RecyclerGraphql', companyLogo?: { __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | null } } };

export type CurrentUserOnboardingQueryVariables = Exact<{
  onboardingFilters?: InputMaybe<CompanyOnboardingInputGraphql>;
}>;


export type CurrentUserOnboardingQuery = { __typename?: 'Query', me: { __typename?: 'CurrentUserGraphql', client: { __typename?: 'ProducerGraphql', onboardingDone?: boolean | null, onboardingNeeds?: string | null, onboarding: { __typename?: 'CompanyOnboardingGraphql', done: boolean, onboardingItems?: Array<{ __typename?: 'CompanyOnboardingItemGraphql', done: boolean, key: string, value?: string | null }> | null } } | { __typename?: 'RecyclerGraphql' } } };

export type CurrentUserProducersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type CurrentUserProducersQuery = { __typename?: 'Query', me: { __typename?: 'CurrentUserGraphql', client: { __typename?: 'ProducerGraphql' } | { __typename?: 'RecyclerGraphql', isPremiumRecycler?: boolean | null, producers: { __typename?: 'ProducerCollection', count: number, collection: Array<{ __typename?: 'ProducerGraphql', id: string, name: string, sites: { __typename?: 'SitesCollection', collection: Array<{ __typename?: 'SiteGraphql', address?: string | null, name?: string | null, id: string, zipCode?: string | null } | null> } } | null> } } } };

export type CurrentUserRecyclersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type CurrentUserRecyclersQuery = { __typename?: 'Query', me: { __typename?: 'CurrentUserGraphql', client: { __typename?: 'ProducerGraphql', recyclers: { __typename?: 'RecyclerCollection', count: number, collection: Array<{ __typename?: 'RecyclerGraphql', isPremiumRecycler?: boolean | null, id: string, name: string, siret?: string | null, address?: { __typename?: 'AddressGraphql', line1?: string | null, country?: string | null, city?: string | null } | null, sites: { __typename?: 'SitesCollection', collection: Array<{ __typename?: 'SiteGraphql', address?: string | null, name?: string | null, id: string, zipCode?: string | null } | null> } } | null> } } | { __typename?: 'RecyclerGraphql' } } };

export type CurrentUserTreatmentCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserTreatmentCodesQuery = { __typename?: 'Query', me: { __typename?: 'CurrentUserGraphql', organization: { __typename?: 'OrganizationGraphql', id: string, treatmentCodes?: Array<{ __typename?: 'CustomTreatmentCodeGraphql', customTreatmentKind?: string | null, code: TreatmentCodeKey, description: string, isRemapped?: boolean | null } | { __typename?: 'RegularTreatmentCodeGraphql', treatmentKind?: TreatmentName | null, code: TreatmentCodeKey, description: string, isRemapped?: boolean | null }> | null } } };

export type UpdateMetabaseDashboardMutationVariables = Exact<{
  input: UpdateMetabaseDashboardInput;
}>;


export type UpdateMetabaseDashboardMutation = { __typename?: 'Mutation', updateMetabaseDashboard: boolean };

export type ClientDocumentsQueryVariables = Exact<{
  filters?: InputMaybe<ClientFilterGraphql>;
}>;


export type ClientDocumentsQuery = { __typename?: 'Query', clients: { __typename?: 'ClientCollection', collection: Array<{ __typename?: 'ProducerGraphql', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } } | { __typename?: 'RecyclerGraphql', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } } | null> } };

export type CollectsDocumentsQueryVariables = Exact<{
  filters?: InputMaybe<CollectGraphqlFilters>;
}>;


export type CollectsDocumentsQuery = { __typename?: 'Query', collects: { __typename?: 'CollectsCollection', collection: Array<{ __typename?: 'CollectGraphql', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } } | null> } };

export type CollectedContainerDocumentsQueryVariables = Exact<{
  filters?: InputMaybe<CollectedContainerGraphqlFilters>;
  documentsFilters?: InputMaybe<StoredDocumentFilters>;
}>;


export type CollectedContainerDocumentsQuery = { __typename?: 'Query', collectedContainers: { __typename?: 'CollectedContainerCollection', collection: Array<{ __typename?: 'CollectedContainerGraphql', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } } | null> } };

export type ContainerDocumentsQueryVariables = Exact<{
  filters?: InputMaybe<ContainerFiltersGraphql>;
}>;


export type ContainerDocumentsQuery = { __typename?: 'Query', containers: { __typename?: 'ContainerCollection', collection: Array<{ __typename?: 'ContainerGraphql', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } } | null> } };

export type IncidentDocumentsQueryVariables = Exact<{
  filters?: InputMaybe<IncidentFiltersGraphql>;
}>;


export type IncidentDocumentsQuery = { __typename?: 'Query', incidents: { __typename?: 'IncidentCollection', collection: Array<{ __typename?: 'AccessibilityIncidentGraphql', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } } | { __typename?: 'MaterialUnavailableIncidentGraphql', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } } | { __typename?: 'NonConformityIncidentGraphql', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } } | { __typename?: 'OtherIncidentGraphql', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } } | null> } };

export type MaterialDocumentsQueryVariables = Exact<{
  filters?: InputMaybe<MaterialFiltersGraphql>;
}>;


export type MaterialDocumentsQuery = { __typename?: 'Query', materials: { __typename?: 'MaterialCollection', collection: Array<{ __typename?: 'MaterialGraphql', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } } | null> } };

export type ProducerRequestDocumentsQueryVariables = Exact<{
  filters?: InputMaybe<ProducerRequestFiltersGraphql>;
}>;


export type ProducerRequestDocumentsQuery = { __typename?: 'Query', producerRequestsByClientId: { __typename?: 'ProducerRequestsCollection', collection: Array<{ __typename?: 'ProducerRequestGraphql', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } } | null> } };

export type AcceptRecyclerInvoiceToProducerRequestAndCreateMaterialMutationVariables = Exact<{
  input: AcceptRecyclerInvoiceToProducerRequestAndCreateMaterialInput;
}>;


export type AcceptRecyclerInvoiceToProducerRequestAndCreateMaterialMutation = { __typename?: 'Mutation', acceptRecyclerInvoiceToProducerRequestAndCreateMaterial: { __typename?: 'RecyclerResponseGraphql', id: string } };

export type CreateProducerRequestMutationVariables = Exact<{
  input: CreateProducerRequestInput;
}>;


export type CreateProducerRequestMutation = { __typename?: 'Mutation', createProducerRequest: { __typename?: 'ProducerRequestGraphql', id: string } };

export type MaterialsQueryVariables = Exact<{
  filters: MaterialFiltersGraphql;
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type MaterialsQuery = { __typename?: 'Query', materials: { __typename?: 'MaterialCollection', count: number, collection: Array<{ __typename?: 'MaterialGraphql', capCode?: string | null, consistency: MaterialConsistence, id: string, price?: number | null, isSold?: boolean | null, name: string, wasteCode?: string | null, UNCode?: string | null, capCodeExpiresAt?: any | null, notes?: string | null, isArchived: boolean, recycler?: { __typename?: 'RecyclerGraphql', name: string, id: string, isPremiumRecycler?: boolean | null, organization: { __typename?: 'OrganizationGraphql', id: string } } | null, pricingForCurrentRecycler?: { __typename?: 'DefaultPricingGraphql', id: string, price: number, vat: number } | { __typename?: 'WPSpecificPricingGraphql', id: string, price: number, vat: number } | null, container: Array<{ __typename?: 'ContainerGraphql', id: string, name?: string | null, type?: ContainerType | null, quantity?: number | null, unit?: string | null }>, standardMaterial: { __typename?: 'StandardMaterialGraphql', attributes: string, category: string, consistency: MaterialConsistence, isDangerous: boolean, subCategory: string, shape: string, id: string, name: string }, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } } | null> } };

export type ProducerRequestQueryVariables = Exact<{
  filters?: InputMaybe<ProducerRequestFiltersGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type ProducerRequestQuery = { __typename?: 'Query', producerRequestsByClientId: { __typename?: 'ProducerRequestsCollection', count: number, collection: Array<{ __typename?: 'ProducerRequestGraphql', id: string, materialName: string, quantity?: number | null, onSiteIdentificationRequests: boolean, isRecurring: boolean, description?: string | null, createdAt: any, status: ProducerRequestStatus, urgentRequest: boolean, wasteCode?: string | null, producer: { __typename?: 'ProducerGraphql', name: string, id: string } | { __typename?: 'RecyclerGraphql', name: string, id: string }, responses: { __typename?: 'RecyclerResponsesCollection', count: number, collection: Array<{ __typename?: 'RecyclerResponseGraphql', id: string, status: RecyclerResponseStatus, notes?: string | null, price?: number | null, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } | null> }, photo?: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> } | null, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string } | null> }, site: { __typename?: 'SiteGraphql', name?: string | null, id: string } } | null> } };

export type RecyclerResponsesByClientIdQueryVariables = Exact<{
  filters?: InputMaybe<RecyclerResponseFiltersGraphql>;
}>;


export type RecyclerResponsesByClientIdQuery = { __typename?: 'Query', recyclerResponsesByClientId: { __typename?: 'RecyclerResponsesCollection', count: number, collection: Array<{ __typename?: 'RecyclerResponseGraphql', status: RecyclerResponseStatus, id: string, request: { __typename?: 'ProducerRequestGraphql', id: string, isRecurring: boolean, onSiteIdentificationRequests: boolean, materialName: string, urgentRequest: boolean, wasteCode?: string | null, description?: string | null, quantity?: number | null, site: { __typename?: 'SiteGraphql', id: string, name?: string | null }, photo?: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType } | null> } | null, producer: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string }, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType, extension: string } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType, extension: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType, extension: string } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType, extension: string } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType, extension: string } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType, extension: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string, type: DocumentType, extension: string } | null> } } } | null> } };

export type RecyclerPendingResponsesQueryVariables = Exact<{
  filters?: InputMaybe<RecyclerResponseFiltersGraphql>;
}>;


export type RecyclerPendingResponsesQuery = { __typename?: 'Query', recyclerResponsesByClientId: { __typename?: 'RecyclerResponsesCollection', count: number, collection: Array<{ __typename?: 'RecyclerResponseGraphql', status: RecyclerResponseStatus, id: string, request: { __typename?: 'ProducerRequestGraphql', id: string, materialName: string, description?: string | null } } | null> } };

export type RespondToProducerRequestMutationVariables = Exact<{
  input: RecyclerResponseInput;
}>;


export type RespondToProducerRequestMutation = { __typename?: 'Mutation', respondToProducerRequest: { __typename?: 'RecyclerResponseGraphql', id: string, price?: number | null, notes?: string | null, acceptedAt?: any | null } };

export type SendProducerRequestToRecyclerMutationVariables = Exact<{
  input: SendProducerRequestToRecyclerInput;
}>;


export type SendProducerRequestToRecyclerMutation = { __typename?: 'Mutation', sendProducerRequestToRecycler: { __typename?: 'ProducerRequestGraphql', id: string } };

export type TreatmentCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type TreatmentCodesQuery = { __typename?: 'Query', treatmentCodes: Array<{ __typename?: 'CustomTreatmentCodeGraphql', customTreatmentKind?: string | null, code: TreatmentCodeKey, description: string, isRemapped?: boolean | null } | { __typename?: 'RegularTreatmentCodeGraphql', treatmentKind?: TreatmentName | null, code: TreatmentCodeKey, description: string, isRemapped?: boolean | null }> };

export type GetWasteCodeEuQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWasteCodeEuQuery = { __typename?: 'Query', wasteCodes: Array<{ __typename?: 'WasteCodesGraphql', categoryCode: string, categoryDescription: string, subCategories: Array<{ __typename?: 'WasteCodeSubCategoryGraphql', subCategoryCode: string, subCategoryDescription: string, codes: Array<{ __typename?: 'WasteCodeGraphql', code: string, description: string }> }> }> };

export type HealthcheckQueryVariables = Exact<{ [key: string]: never; }>;


export type HealthcheckQuery = { __typename?: 'Query', healthcheck: string };

export type SignUpMutationVariables = Exact<{
  input: SignUpInputGraphql;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } };

export type LogAsMutationVariables = Exact<{
  input: LogAsInput;
}>;


export type LogAsMutation = { __typename?: 'Mutation', logAs?: { __typename?: 'LoggedAs', userJWT: string } | null };

export type CurrentUserCrucialFieldsQueryVariables = Exact<{
  input?: InputMaybe<ClientCustomDashboardInputGraphql>;
}>;


export type CurrentUserCrucialFieldsQuery = { __typename?: 'Query', me: { __typename?: 'CurrentUserGraphql', organization: { __typename?: 'OrganizationGraphql', id: string }, client: { __typename: 'ProducerGraphql', id: string, name: string, isConnectedToTrackdechets?: boolean | null, autosignEnabledForTrackdechets: boolean, customDashboard?: string | null, hasCollects: boolean } | { __typename: 'RecyclerGraphql', id: string, name: string, isConnectedToTrackdechets?: boolean | null, autosignEnabledForTrackdechets: boolean, customDashboard?: string | null, hasCollects: boolean }, user: { __typename?: 'UserGraphql', email?: string | null, firstName?: string | null, id: string, lastName?: string | null, role: UserRoles, acceptedTermsAt?: any | null, entitlements: { __typename?: 'EntitlementsGraphql', companies?: Array<{ __typename?: 'LocationEntitlementGraphql', id?: string | null, role?: string | null }> | null, organisations?: Array<{ __typename?: 'LocationEntitlementGraphql', id?: string | null, role?: string | null }> | null, sites?: Array<{ __typename?: 'LocationEntitlementGraphql', id?: string | null, role?: string | null }> | null }, assignedRoles: { __typename?: 'AssignedRolesCollection', collection: Array<{ __typename?: 'AssignedRoleGraphql', role: { __typename?: 'CompanyRole', id: string, name: string, company: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } | { __typename?: 'OrganizationRole', id: string, name: string, organization: { __typename?: 'OrganizationGraphql', id: string, name: string } } | { __typename?: 'SiteRole', id: string, name: string, site: { __typename?: 'SiteGraphql', id: string, name?: string | null } } } | null> } } } };

export type RecyclerCapabilitiesQueryVariables = Exact<{
  filters: RecyclerCapabilityGraphqlFilter;
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type RecyclerCapabilitiesQuery = { __typename?: 'Query', recyclerCapabilities: { __typename?: 'RecyclerCapabilityCollection', count: number, collection: Array<{ __typename?: 'RecyclerCapabilityGraphql', id: string, treatmentCode: string, createdAt: any, capExpiresAt?: any | null, capCode?: string | null, outletName?: string | null, client: { __typename?: 'RecyclerGraphql', id: string, name: string }, standardMaterial: { __typename?: 'StandardMaterialGraphql', name: string, id: string, consistency: MaterialConsistence, isDangerous: boolean, category: string }, outlet: { __typename?: 'RecyclerGraphql', name: string, siret?: string | null, address?: { __typename?: 'AddressGraphql', line1?: string | null } | null } } | null> } };

export type CreateCapabilityMutationVariables = Exact<{
  input: CreateCapabilityInputGraphql;
}>;


export type CreateCapabilityMutation = { __typename?: 'Mutation', addRecyclerCapability: { __typename?: 'RecyclerCapabilityGraphql', id: string, treatmentCode: string, createdAt: any, capExpiresAt?: any | null, capCode?: string | null, outletName?: string | null, client: { __typename?: 'RecyclerGraphql', id: string, name: string }, standardMaterial: { __typename?: 'StandardMaterialGraphql', name: string, id: string, consistency: MaterialConsistence, isDangerous: boolean, category: string }, outlet: { __typename?: 'RecyclerGraphql', siret?: string | null, name: string, address?: { __typename?: 'AddressGraphql', line1?: string | null } | null } } };

export type DeleteCapabilityMutationVariables = Exact<{
  input: DeleteCapabilityGraphql;
}>;


export type DeleteCapabilityMutation = { __typename?: 'Mutation', deleteCapability: boolean };

export type ClientsQueryVariables = Exact<{
  pagination: PaginationArgs;
  filters: ClientFilterGraphql;
}>;


export type ClientsQuery = { __typename?: 'Query', clients: { __typename?: 'ClientCollection', count: number, collection: Array<{ __typename?: 'ProducerGraphql', paysMonthlyFees?: number | null, type: ClientType, id: string, contactFirstName?: string | null, contactLastName?: string | null, iban?: string | null, isConnectedToTrackdechets?: boolean | null, name: string, phoneNumber?: string | null, siret?: string | null, slug: string, bic?: string | null, onboardingNeeds?: string | null, autosignEnabledForTrackdechets: boolean, recyclers: { __typename?: 'RecyclerCollection', collection: Array<{ __typename?: 'RecyclerGraphql', id: string, name: string } | null> }, companyLogo?: { __typename?: 'ClientDocumentGraphql', id: string, signedUrl: string } | null, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'CollectDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'ContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'IncidentDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'MaterialDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | null> }, sites: { __typename?: 'SitesCollection', collection: Array<{ __typename?: 'SiteGraphql', name?: string | null, id: string } | null> } } | { __typename?: 'RecyclerGraphql', percentageRecyclerRevshare?: number | null, paysMonthlyFees?: number | null, transporterReceipt?: string | null, type: ClientType, id: string, contactFirstName?: string | null, contactLastName?: string | null, iban?: string | null, isConnectedToTrackdechets?: boolean | null, name: string, phoneNumber?: string | null, siret?: string | null, slug: string, bic?: string | null, onboardingNeeds?: string | null, autosignEnabledForTrackdechets: boolean, companyLogo?: { __typename?: 'ClientDocumentGraphql', id: string, signedUrl: string } | null, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'CollectDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'ContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'IncidentDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'MaterialDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | null> }, sites: { __typename?: 'SitesCollection', collection: Array<{ __typename?: 'SiteGraphql', name?: string | null, id: string } | null> } } | null> } };

export type ClientQueryVariables = Exact<{
  pagination: PaginationArgs;
  filters: ClientFilterGraphql;
}>;


export type ClientQuery = { __typename?: 'Query', clients: { __typename?: 'ClientCollection', count: number, collection: Array<{ __typename?: 'ProducerGraphql', paysMonthlyFees?: number | null, id: string, type: ClientType, contactFirstName?: string | null, contactLastName?: string | null, iban?: string | null, isConnectedToTrackdechets?: boolean | null, autosignEnabledForTrackdechets: boolean, name: string, phoneNumber?: string | null, siret?: string | null, slug: string, bic?: string | null, recyclers: { __typename?: 'RecyclerCollection', collection: Array<{ __typename?: 'RecyclerGraphql', id: string, name: string, contactFirstName?: string | null, contactLastName?: string | null } | null> }, companyLogo?: { __typename?: 'ClientDocumentGraphql', id: string, signedUrl: string } | null, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'CollectDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'ContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'IncidentDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'MaterialDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | null> }, sites: { __typename?: 'SitesCollection', collection: Array<{ __typename?: 'SiteGraphql', name?: string | null, id: string } | null> } } | { __typename?: 'RecyclerGraphql', percentageRecyclerRevshare?: number | null, paysMonthlyFees?: number | null, transporterReceipt?: string | null, id: string, type: ClientType, contactFirstName?: string | null, contactLastName?: string | null, iban?: string | null, isConnectedToTrackdechets?: boolean | null, autosignEnabledForTrackdechets: boolean, name: string, phoneNumber?: string | null, siret?: string | null, slug: string, bic?: string | null, producers: { __typename?: 'ProducerCollection', collection: Array<{ __typename?: 'ProducerGraphql', id: string, name: string, contactFirstName?: string | null, contactLastName?: string | null } | null> }, companyLogo?: { __typename?: 'ClientDocumentGraphql', id: string, signedUrl: string } | null, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'CollectDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'ContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'IncidentDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'MaterialDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, extension: string, createdAt: any } | null> }, sites: { __typename?: 'SitesCollection', collection: Array<{ __typename?: 'SiteGraphql', name?: string | null, id: string } | null> } } | null> } };

export type ClientsForSelectQueryVariables = Exact<{
  pagination: PaginationArgs;
  filters: ClientFilterGraphql;
}>;


export type ClientsForSelectQuery = { __typename?: 'Query', clients: { __typename?: 'ClientCollection', collection: Array<{ __typename?: 'ProducerGraphql', id: string, contactFirstName?: string | null, contactLastName?: string | null, name: string } | { __typename?: 'RecyclerGraphql', id: string, contactFirstName?: string | null, contactLastName?: string | null, name: string } | null> } };

export type UpdateClientMutationVariables = Exact<{
  input: ClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } };

export type CreateClientMutationVariables = Exact<{
  input: CreateClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'ProducerGraphql', bic?: string | null, autosignEnabledForTrackdechets: boolean, contactFirstName?: string | null, contactLastName?: string | null, iban?: string | null, id: string, name: string, phoneNumber?: string | null, siret?: string | null } | { __typename?: 'RecyclerGraphql', bic?: string | null, autosignEnabledForTrackdechets: boolean, contactFirstName?: string | null, contactLastName?: string | null, iban?: string | null, id: string, name: string, phoneNumber?: string | null, siret?: string | null } };

export type AddProducersToRecyclerMutationVariables = Exact<{
  input: ProducersToRecyclerInput;
}>;


export type AddProducersToRecyclerMutation = { __typename?: 'Mutation', addProducersToRecycler: { __typename?: 'RecyclerGraphql', id: string } };

export type AddRecyclersToProducerMutationVariables = Exact<{
  input: RecyclersToProducerInput;
}>;


export type AddRecyclersToProducerMutation = { __typename?: 'Mutation', addRecyclersToProducer: { __typename?: 'ProducerGraphql', id: string } };

export type RemoveRecyclersFromProducerMutationVariables = Exact<{
  input: RecyclersToProducerInput;
}>;


export type RemoveRecyclersFromProducerMutation = { __typename?: 'Mutation', removeRecyclersFromProducer: { __typename?: 'ProducerGraphql', id: string } };

export type RemoveProducersFromRecyclerMutationVariables = Exact<{
  input: ProducersToRecyclerInput;
}>;


export type RemoveProducersFromRecyclerMutation = { __typename?: 'Mutation', removeProducersFromRecycler: { __typename?: 'RecyclerGraphql', id: string } };

export type UpdateOrganizationConfigurationMutationVariables = Exact<{
  input: UpdateOrganizationConfigurationInputGraphql;
}>;


export type UpdateOrganizationConfigurationMutation = { __typename?: 'Mutation', updateOrganizationConfiguration: { __typename?: 'OrganizationGraphql', id: string } };

export type CollectedContainersQueryVariables = Exact<{
  filters?: InputMaybe<CollectedContainerGraphqlFilters>;
  pagination?: InputMaybe<PaginationArgs>;
  documentsFilters?: InputMaybe<StoredDocumentFilters>;
}>;


export type CollectedContainersQuery = { __typename?: 'Query', collectedContainers: { __typename?: 'CollectedContainerCollection', collection: Array<{ __typename?: 'CollectedContainerGraphql', id: string, quantity?: number | null, treatmentCode?: string | null, unit?: string | null, collect: { __typename?: 'CollectGraphql', id: string, startsAt?: any | null, endsAt?: any | null, status: CollectStatus, npsRating?: { __typename?: 'NPSGraphql', rating: number } | null, recycler?: { __typename?: 'RecyclerGraphql', name: string } | null }, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string, id: string, subtype?: DocumentMetaSubtypes | null, extension: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, id: string, subtype?: DocumentMetaSubtypes | null, extension: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', invoiceCertainty?: string | null, signedUrl: string, id: string, subtype?: DocumentMetaSubtypes | null, extension: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, id: string, subtype?: DocumentMetaSubtypes | null, extension: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, id: string, subtype?: DocumentMetaSubtypes | null, extension: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, id: string, subtype?: DocumentMetaSubtypes | null, extension: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, id: string, subtype?: DocumentMetaSubtypes | null, extension: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> }, BSD?: { __typename?: 'BSDGraphql', id: string, state: CollectBsdState, tdState: TrackdechetsBsdState } | null, container?: { __typename?: 'ContainerGraphql', id: string, name?: string | null } | null, material?: { __typename?: 'MaterialGraphql', id: string, name: string, pricingForCurrentRecycler?: { __typename?: 'DefaultPricingGraphql', price: number, vat: number } | { __typename?: 'WPSpecificPricingGraphql', price: number, vat: number } | null, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'CollectDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', id: string, signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, signedUrl: string } | null> } } | null } | null> } };

export type UpdateCollectedContainerMutationVariables = Exact<{
  input: UpdateCollectedContainerInput;
}>;


export type UpdateCollectedContainerMutation = { __typename?: 'Mutation', updateCollectedContainer: { __typename?: 'CollectedContainerGraphql', quantity?: number | null, treatmentCode?: string | null, id: string } };

export type CollectedContainerDetailsSummaryQueryVariables = Exact<{
  input?: InputMaybe<PricingSummaryInputGraphql>;
  filters?: InputMaybe<CollectedContainerGraphqlFilters>;
}>;


export type CollectedContainerDetailsSummaryQuery = { __typename?: 'Query', collectedContainers: { __typename: 'CollectedContainerCollection', collection: Array<{ __typename?: 'CollectedContainerGraphql', id: string, pricingSummary: { __typename?: 'CollectPricingSummaryGraphql', ready: boolean, summary?: { __typename?: 'CollectPricingSummaryDetailsGraphql', incidentsTotalWithTax: number, incidentsTotalWithoutTax: number, totalTax: number, totalWithTax: number, totalWithoutTax: number, transportTotalWithTax: number, transportTotalWithoutTax: number, totalTreatmentWithTax: number, totalTreatmentWithoutTax: number, totalResaleWithoutTax: number, totalResaleWithTax: number } | null } } | null> } };

export type SignBsdMutationVariables = Exact<{
  input: SignBsdInput;
}>;


export type SignBsdMutation = { __typename?: 'Mutation', signBSDs: Array<{ __typename?: 'BSDGraphql', id: string, state: CollectBsdState, tdState: TrackdechetsBsdState }> };

export type SignAllCollectBsDsMutationVariables = Exact<{
  input: SignAllCollectBsDsInput;
}>;


export type SignAllCollectBsDsMutation = { __typename?: 'Mutation', signAllCollectBSDs: Array<{ __typename?: 'BSDGraphql', id: string, state: CollectBsdState, tdState: TrackdechetsBsdState }> };

export type CollectDetailsSummaryQueryVariables = Exact<{
  input?: InputMaybe<PricingSummaryInputGraphql>;
  filters?: InputMaybe<CollectGraphqlFilters>;
}>;


export type CollectDetailsSummaryQuery = { __typename?: 'Query', collects: { __typename: 'CollectsCollection', collection: Array<{ __typename?: 'CollectGraphql', id: string, pricingSummary?: { __typename?: 'CollectPricingSummaryGraphql', ready: boolean, summary?: { __typename?: 'CollectPricingSummaryDetailsGraphql', incidentsTotalWithTax: number, incidentsTotalWithoutTax: number, totalTax: number, totalWithTax: number, totalWithoutTax: number, transportTotalWithTax: number, transportTotalWithoutTax: number, totalTreatmentWithTax: number, totalTreatmentWithoutTax: number, totalResaleWithoutTax: number, totalResaleWithTax: number } | null } | null } | null> } };

export type CollectSingleQueryVariables = Exact<{
  pagination: PaginationArgs;
  filters?: InputMaybe<CollectGraphqlFilters>;
  isAdmin: Scalars['Boolean']['input'];
}>;


export type CollectSingleQuery = { __typename?: 'Query', collects: { __typename?: 'CollectsCollection', collection: Array<{ __typename?: 'CollectGraphql', notes?: string | null, status: CollectStatus, id: string, transportPrice?: number | null, startsAt?: any | null, endsAt?: any | null, licensePlate?: string | null, missingInformations: Array<string>, notifications?: { __typename?: 'NotificationGraphql', wrNotifiedAt?: string | null, wpCollectUpdated?: string | null, wpDocumentsReadyNotifiedAt?: string | null, wrCollectConfirmedNotifiedAt?: string | null } | null, pricingSummary?: { __typename?: 'CollectPricingSummaryGraphql', ready: boolean } | null, npsRating?: { __typename?: 'NPSGraphql', additionalDetails?: string | null, rating: number } | null, BSDs: { __typename?: 'BSDCollection', count: number }, client: { __typename?: 'ProducerGraphql', name: string, id: string } | { __typename?: 'RecyclerGraphql', name: string, id: string }, collectedContainers: { __typename?: 'CollectedContainerCollection', collection: Array<{ __typename?: 'CollectedContainerGraphql', id: string, quantity?: number | null, treatmentCode?: string | null, unit?: string | null, missingInformations?: Array<string> | null, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string, name: string, type: DocumentType, id: string, extension: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, name: string, type: DocumentType, id: string, extension: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', subtype?: DocumentMetaSubtypes | null, signedUrl: string, name: string, type: DocumentType, id: string, extension: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, name: string, type: DocumentType, id: string, extension: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, name: string, type: DocumentType, id: string, extension: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, name: string, type: DocumentType, id: string, extension: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, name: string, type: DocumentType, id: string, extension: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> }, container?: { __typename?: 'ContainerGraphql', name?: string | null, id: string } | null, material?: { __typename?: 'MaterialGraphql', id: string, name: string, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string, name: string, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, name: string, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', signedUrl: string, name: string, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, name: string, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, name: string, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, name: string, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, name: string, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> }, pricingForCurrentRecycler?: { __typename?: 'DefaultPricingGraphql', id: string, price: number, vat: number } | { __typename?: 'WPSpecificPricingGraphql', id: string, price: number, vat: number } | null } | null } | null> }, recycler?: { __typename?: 'RecyclerGraphql', id: string, name: string } | null, isInvoiceable: { __typename?: 'CollectInvoiceGraphql', errors: Array<string | null>, alreadyInvoiced: boolean, result: boolean } } | null> } };

export type CollectListQueryVariables = Exact<{
  pagination: PaginationArgs;
  filters?: InputMaybe<CollectGraphqlFilters>;
}>;


export type CollectListQuery = { __typename?: 'Query', collects: { __typename?: 'CollectsCollection', count: number, collection: Array<{ __typename?: 'CollectGraphql', status: CollectStatus, id: string, startsAt?: any | null, endsAt?: any | null, createdAt: any, npsRating?: { __typename?: 'NPSGraphql', additionalDetails?: string | null, rating: number } | null, client: { __typename?: 'ProducerGraphql', name: string, id: string, organization: { __typename?: 'OrganizationGraphql', id: string } } | { __typename?: 'RecyclerGraphql', name: string, id: string, organization: { __typename?: 'OrganizationGraphql', id: string } }, collectedContainers: { __typename?: 'CollectedContainerCollection', collection: Array<{ __typename?: 'CollectedContainerGraphql', id: string, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string, id: string, name: string } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, id: string, name: string } | { __typename?: 'CollectedContainerDocumentGraphql', signedUrl: string, id: string, name: string } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, id: string, name: string } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, id: string, name: string } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, id: string, name: string } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, id: string, name: string } | null> }, material?: { __typename?: 'MaterialGraphql', id: string, name: string } | null } | null> } } | null> } };

export type CreateCollectMutationVariables = Exact<{
  input: CreateCollectGraphql;
}>;


export type CreateCollectMutation = { __typename?: 'Mutation', createCollect: { __typename?: 'CollectGraphql', id: string, collectedContainers: { __typename?: 'CollectedContainerCollection', collection: Array<{ __typename?: 'CollectedContainerGraphql', id: string, material?: { __typename?: 'MaterialGraphql', id: string, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string } | { __typename?: 'CollectDocumentGraphql', signedUrl: string } | { __typename?: 'CollectedContainerDocumentGraphql', signedUrl: string } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string } | null> } } | null, container?: { __typename?: 'ContainerGraphql', id: string } | null } | null> } } };

export type UpdateCollectInformationsMutationVariables = Exact<{
  input: UpdateCollectInformationsGraphql;
}>;


export type UpdateCollectInformationsMutation = { __typename?: 'Mutation', updateCollectInformations: { __typename?: 'CollectGraphql', id: string, status: CollectStatus, startsAt?: any | null, endsAt?: any | null, notes?: string | null, licensePlate?: string | null, transportPrice?: number | null, referent: { __typename?: 'PartialUserGraphql', firstName?: string | null, id: string, lastName?: string | null } } };

export type BoCollectListQueryVariables = Exact<{
  pagination: PaginationArgs;
  filters?: InputMaybe<CollectGraphqlFilters>;
}>;


export type BoCollectListQuery = { __typename?: 'Query', collects: { __typename?: 'CollectsCollection', count: number, collection: Array<{ __typename?: 'CollectGraphql', id: string, status: CollectStatus, createdAt: any, endsAt?: any | null, startsAt?: any | null, isInvoiceable: { __typename?: 'CollectInvoiceGraphql', alreadyInvoiced: boolean, errors: Array<string | null>, result: boolean }, client: { __typename?: 'ProducerGraphql', name: string, id: string, organization: { __typename?: 'OrganizationGraphql', id: string } } | { __typename?: 'RecyclerGraphql', name: string, id: string, organization: { __typename?: 'OrganizationGraphql', id: string } }, collectedContainers: { __typename?: 'CollectedContainerCollection', collection: Array<{ __typename?: 'CollectedContainerGraphql', id: string, quantity?: number | null, material?: { __typename?: 'MaterialGraphql', id: string, name: string } | null, container?: { __typename?: 'ContainerGraphql', name?: string | null, id: string } | null } | null> }, recycler?: { __typename?: 'RecyclerGraphql', id: string, name: string, organization: { __typename?: 'OrganizationGraphql', id: string } } | null } | null> } };

export type CancelCollectMutationVariables = Exact<{
  input: CancelCollectInputGraphql;
}>;


export type CancelCollectMutation = { __typename?: 'Mutation', cancelCollect: { __typename?: 'CollectGraphql', status: CollectStatus, id: string } };

export type RateCollectNpsMutationVariables = Exact<{
  input: RateCollectNpsInputGraphql;
}>;


export type RateCollectNpsMutation = { __typename?: 'Mutation', rateCollectNPS: { __typename?: 'CollectGraphql', id: string, npsRating?: { __typename?: 'NPSGraphql', additionalDetails?: string | null, rating: number } | null } };

export type ReferentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferentsQuery = { __typename?: 'Query', referents: { __typename?: 'PartialUserCollection', collection: Array<{ __typename?: 'PartialUserGraphql', firstName?: string | null, id: string, lastName?: string | null } | null> } };

export type ComplianceStructureQueryVariables = Exact<{ [key: string]: never; }>;


export type ComplianceStructureQuery = { __typename?: 'Query', compliancePageStructure: Array<{ __typename?: 'ComplianceStructureNodeGraphql', category: string, hasDocumentLink: boolean, hasExternalPageLink: boolean, id: string, label: string }> };

export type ComplianceDataQueryVariables = Exact<{
  filter?: InputMaybe<ComplianceNodeGraphqlFilter>;
}>;


export type ComplianceDataQuery = { __typename?: 'Query', compliancePage: Array<{ __typename?: 'ComplianceBasicNodeGraphql', category: string, id: string, label: string, notes: string, value: boolean, state?: ComplianceNodeState | null } | { __typename?: 'ComplianceDocumentNodeGraphql', category: string, id: string, label: string, notes: string, value: boolean, state?: ComplianceNodeState | null, document: { __typename?: 'ClientDocumentGraphql', signedUrl: string, id: string, name: string } } | { __typename?: 'ComplianceLinkNodeGraphql', link: string, category: string, id: string, label: string, notes: string, value: boolean, state?: ComplianceNodeState | null }> };

export type AddCompliancePageDataMutationVariables = Exact<{
  input: ComplianceNodeGraphqlInputList;
}>;


export type AddCompliancePageDataMutation = { __typename?: 'Mutation', addCompliancePageData: Array<{ __typename?: 'ComplianceBasicNodeGraphql', category: string, id: string, label: string, notes: string, value: boolean, state?: ComplianceNodeState | null } | { __typename?: 'ComplianceDocumentNodeGraphql', category: string, id: string, label: string, notes: string, value: boolean, state?: ComplianceNodeState | null } | { __typename?: 'ComplianceLinkNodeGraphql', category: string, id: string, label: string, notes: string, value: boolean, state?: ComplianceNodeState | null }> };

export type ContainersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArgs>;
  filters?: InputMaybe<ContainerFiltersGraphql>;
}>;


export type ContainersQuery = { __typename?: 'Query', containers: { __typename?: 'ContainerCollection', count: number, collection: Array<{ __typename?: 'ContainerGraphql', name?: string | null, quantity?: number | null, type?: ContainerType | null, unit?: string | null, id: string, site?: { __typename?: 'SiteGraphql', id: string, name?: string | null } | null, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, signedUrl: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', id: string, signedUrl: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, signedUrl: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', id: string, signedUrl: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', id: string, signedUrl: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', id: string, signedUrl: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, signedUrl: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> }, material: { __typename?: 'MaterialGraphql', id: string, name: string, wasteCode?: string | null, UNCode?: string | null, capCodeExpiresAt?: any | null, capCode?: string | null, consistency: MaterialConsistence, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'CollectDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'ContainerDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'IncidentDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'MaterialDocumentGraphql', id: string, signedUrl: string, name: string } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, signedUrl: string, name: string } | null> } } } | null> } };

export type UpsertContainerMutationVariables = Exact<{
  input: UpsertContainerGraphql;
}>;


export type UpsertContainerMutation = { __typename?: 'Mutation', upsertContainer: { __typename?: 'ContainerGraphql', id: string, name?: string | null, quantity?: number | null, type?: ContainerType | null, unit?: string | null, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', id: string, name: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', id: string, name: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', id: string, name: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', id: string, name: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', id: string, name: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', id: string, name: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', id: string, name: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> }, material: { __typename?: 'MaterialGraphql', name: string, id: string }, site?: { __typename?: 'SiteGraphql', id: string, name?: string | null } | null } };

export type DeleteContainerMutationVariables = Exact<{
  input: DeleteContainerGraphql;
}>;


export type DeleteContainerMutation = { __typename?: 'Mutation', deleteContainer: boolean };

export type DashboardQueryVariables = Exact<{
  input?: InputMaybe<ClientCustomDashboardInputGraphql>;
}>;


export type DashboardQuery = { __typename?: 'Query', getDashboardUrl?: string | null };

export type ImportLegacyDataMutationVariables = Exact<{
  input: LegacyDataImportInput;
}>;


export type ImportLegacyDataMutation = { __typename?: 'Mutation', importLegacyDataSpreadsheet: boolean };

export type DocumentsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArgs>;
  filters: StoredDocumentFilters;
}>;


export type DocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'StoredDocumentCollection', count: number, collection: Array<{ __typename?: 'ClientDocumentGraphql', subtype?: DocumentMetaSubtypes | null, createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, documentContentRaw?: string | null, type: DocumentType, tags: Array<{ __typename?: 'DocumentTagGraphql', name: string, id: string, color: string } | null>, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', subtype?: DocumentMetaSubtypes | null, createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, documentContentRaw?: string | null, type: DocumentType, tags: Array<{ __typename?: 'DocumentTagGraphql', name: string, id: string, color: string } | null>, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', subtype?: DocumentMetaSubtypes | null, createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, documentContentRaw?: string | null, type: DocumentType, tags: Array<{ __typename?: 'DocumentTagGraphql', name: string, id: string, color: string } | null>, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, documentContentRaw?: string | null, type: DocumentType, tags: Array<{ __typename?: 'DocumentTagGraphql', name: string, id: string, color: string } | null>, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, documentContentRaw?: string | null, type: DocumentType, tags: Array<{ __typename?: 'DocumentTagGraphql', name: string, id: string, color: string } | null>, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, documentContentRaw?: string | null, type: DocumentType, tags: Array<{ __typename?: 'DocumentTagGraphql', name: string, id: string, color: string } | null>, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, documentContentRaw?: string | null, type: DocumentType, tags: Array<{ __typename?: 'DocumentTagGraphql', name: string, id: string, color: string } | null>, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } };

export type CollectDocumentsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArgs>;
  filters?: InputMaybe<CollectDocumentFilters>;
}>;


export type CollectDocumentsQuery = { __typename?: 'Query', collectDocuments: { __typename?: 'StoredDocumentCollection', count: number, collection: Array<{ __typename?: 'ClientDocumentGraphql', createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } | { __typename?: 'CollectDocumentGraphql', subtype?: DocumentMetaSubtypes | null, createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, type: DocumentType, collect: { __typename?: 'CollectGraphql', id: string }, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } | { __typename?: 'CollectedContainerDocumentGraphql', subtype?: DocumentMetaSubtypes | null, createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, type: DocumentType, collectedContainer: { __typename?: 'CollectedContainerGraphql', id: string, collect: { __typename?: 'CollectGraphql', id: string } }, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } | { __typename?: 'ContainerDocumentGraphql', createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } | { __typename?: 'IncidentDocumentGraphql', createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } | { __typename?: 'MaterialDocumentGraphql', createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } | { __typename?: 'ProducerRequestDocumentGraphql', createdAt: any, extension: string, externalReference: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } | null> } };

export type ExtractInvoiceDataMutationVariables = Exact<{
  input: ExtractInvoiceDataInput;
}>;


export type ExtractInvoiceDataMutation = { __typename?: 'Mutation', extractInvoiceData: { __typename?: 'ClientDocumentGraphql', signedUrl: string, name: string, id: string, externalReference: string, extension: string, createdAt: any, subtype?: DocumentMetaSubtypes | null, type: DocumentType } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, name: string, id: string, externalReference: string, extension: string, createdAt: any, subtype?: DocumentMetaSubtypes | null, type: DocumentType } | { __typename?: 'CollectedContainerDocumentGraphql', invoiceCertainty?: string | null, signedUrl: string, name: string, id: string, externalReference: string, extension: string, createdAt: any, subtype?: DocumentMetaSubtypes | null, type: DocumentType } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, name: string, id: string, externalReference: string, extension: string, createdAt: any, subtype?: DocumentMetaSubtypes | null, type: DocumentType } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, name: string, id: string, externalReference: string, extension: string, createdAt: any, subtype?: DocumentMetaSubtypes | null, type: DocumentType } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, name: string, id: string, externalReference: string, extension: string, createdAt: any, subtype?: DocumentMetaSubtypes | null, type: DocumentType } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, name: string, id: string, externalReference: string, extension: string, createdAt: any, subtype?: DocumentMetaSubtypes | null, type: DocumentType } };

export type CollectCsvExtractQueryVariables = Exact<{
  input: CollectCsvExtractInput;
}>;


export type CollectCsvExtractQuery = { __typename?: 'Query', collectCSVExtract: { __typename?: 'CollectCSVExtractGraphql', B64Csv: string } };

export type GenerateWasteRegisterQueryVariables = Exact<{
  input: GenerateWasteRegisterInput;
}>;


export type GenerateWasteRegisterQuery = { __typename?: 'Query', generateWasteRegister: { __typename?: 'DocumentGraphql', content: string, name: string } };

export type GenerateSignedUrlFromIdQueryVariables = Exact<{
  filters: StoredDocumentFilters;
}>;


export type GenerateSignedUrlFromIdQuery = { __typename?: 'Query', documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'CollectedContainerDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, id: string } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, id: string } | null> } };

export type GenerateSignedUploadUrlMutationVariables = Exact<{
  input: GenerateSignedUploadUrlInput;
}>;


export type GenerateSignedUploadUrlMutation = { __typename?: 'Mutation', generateSignedUploadUrl: { __typename?: 'GeneratedSignedUploadUrl', url: string } };

export type StoreDocumentReferenceMutationVariables = Exact<{
  input: StoreDocumentReferenceInput;
}>;


export type StoreDocumentReferenceMutation = { __typename?: 'Mutation', storeDocumentReference: { __typename?: 'ClientDocumentGraphql', extension: string, name: string, type: DocumentType, signedUrl: string, id: string, client: { __typename?: 'ProducerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } | { __typename?: 'RecyclerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } } | { __typename: 'CollectDocumentGraphql', subtype?: DocumentMetaSubtypes | null, extension: string, name: string, type: DocumentType, signedUrl: string, id: string, client: { __typename?: 'ProducerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } | { __typename?: 'RecyclerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } } | { __typename?: 'CollectedContainerDocumentGraphql', extension: string, name: string, type: DocumentType, signedUrl: string, id: string, client: { __typename?: 'ProducerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } | { __typename?: 'RecyclerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } } | { __typename?: 'ContainerDocumentGraphql', extension: string, name: string, type: DocumentType, signedUrl: string, id: string, client: { __typename?: 'ProducerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } | { __typename?: 'RecyclerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } } | { __typename?: 'IncidentDocumentGraphql', extension: string, name: string, type: DocumentType, signedUrl: string, id: string, client: { __typename?: 'ProducerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } | { __typename?: 'RecyclerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } } | { __typename?: 'MaterialDocumentGraphql', extension: string, name: string, type: DocumentType, signedUrl: string, id: string, client: { __typename?: 'ProducerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } | { __typename?: 'RecyclerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } } | { __typename?: 'ProducerRequestDocumentGraphql', extension: string, name: string, type: DocumentType, signedUrl: string, id: string, client: { __typename?: 'ProducerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } | { __typename?: 'RecyclerGraphql', id: string, contactLastName?: string | null, contactFirstName?: string | null, name: string } } };

export type DeleteStoredDocumentMutationVariables = Exact<{
  input: DeleteStoredDocumentGraphqlInput;
}>;


export type DeleteStoredDocumentMutation = { __typename?: 'Mutation', deleteStoredDocument: boolean };

export type CreateDocumentTagMutationVariables = Exact<{
  input: DocumentTagInput;
}>;


export type CreateDocumentTagMutation = { __typename?: 'Mutation', createDocumentTag: { __typename?: 'DocumentTagGraphql', id: string } };

export type DeleteDocumentTagMutationVariables = Exact<{
  input: DeleteDocumentTagInput;
}>;


export type DeleteDocumentTagMutation = { __typename?: 'Mutation', deleteDocumentTag: boolean };

export type AddTagsToDocumentMutationVariables = Exact<{
  input: DocumentTagAddToDocumentInput;
}>;


export type AddTagsToDocumentMutation = { __typename?: 'Mutation', addTagsToDocument: boolean };

export type RemoveTagFromDocumentMutationVariables = Exact<{
  input: DocumentTagRemoveFromDocumentInput;
}>;


export type RemoveTagFromDocumentMutation = { __typename?: 'Mutation', removeTagFromDocument: boolean };

export type DocumentTagsQueryVariables = Exact<{
  filters?: InputMaybe<DocumentTagFilters>;
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type DocumentTagsQuery = { __typename?: 'Query', documentTags: { __typename?: 'DocumentTagCollection', collection: Array<{ __typename?: 'DocumentTagGraphql', name: string, color: string, id: string } | null> } };

export type AdminFieldsFragment = { __typename?: 'CollectGraphql', isInvoiceable: { __typename?: 'CollectInvoiceGraphql', errors: Array<string | null>, alreadyInvoiced: boolean, result: boolean } };

export type CollectPricingSummaryGraphqlFragment = { __typename?: 'CollectGraphql', pricingSummary?: { __typename?: 'CollectPricingSummaryGraphql', ready: boolean, summary?: { __typename?: 'CollectPricingSummaryDetailsGraphql', incidentsTotalWithTax: number, incidentsTotalWithoutTax: number, totalTax: number, totalWithTax: number, totalWithoutTax: number, transportTotalWithTax: number, transportTotalWithoutTax: number, totalTreatmentWithTax: number, totalTreatmentWithoutTax: number, totalResaleWithoutTax: number, totalResaleWithTax: number } | null } | null };

export type CollectedContainerPricingSummaryGraphqlFragment = { __typename?: 'CollectedContainerGraphql', pricingSummary: { __typename?: 'CollectPricingSummaryGraphql', ready: boolean, summary?: { __typename?: 'CollectPricingSummaryDetailsGraphql', incidentsTotalWithTax: number, incidentsTotalWithoutTax: number, totalTax: number, totalWithTax: number, totalWithoutTax: number, transportTotalWithTax: number, transportTotalWithoutTax: number, totalTreatmentWithTax: number, totalTreatmentWithoutTax: number, totalResaleWithoutTax: number, totalResaleWithTax: number } | null } };

export type DeclareIncidentMutationVariables = Exact<{
  input: DeclareIncidentGraphqlInput;
}>;


export type DeclareIncidentMutation = { __typename?: 'Mutation', declareIncident: { __typename?: 'AccessibilityIncidentGraphql', status: IncidentStatus, createdAt: any, id: string, comment?: string | null, type: IncidentType, penaltyAmount?: number | null, penaltyComment?: string | null, createdByUser: { __typename?: 'UserGraphql', firstName?: string | null, lastName?: string | null }, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } } | { __typename?: 'MaterialUnavailableIncidentGraphql', status: IncidentStatus, createdAt: any, id: string, comment?: string | null, type: IncidentType, penaltyAmount?: number | null, penaltyComment?: string | null, createdByUser: { __typename?: 'UserGraphql', firstName?: string | null, lastName?: string | null }, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } } | { __typename?: 'NonConformityIncidentGraphql', status: IncidentStatus, createdAt: any, id: string, comment?: string | null, type: IncidentType, penaltyAmount?: number | null, penaltyComment?: string | null, createdByUser: { __typename?: 'UserGraphql', firstName?: string | null, lastName?: string | null }, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } } | { __typename?: 'OtherIncidentGraphql', status: IncidentStatus, createdAt: any, id: string, comment?: string | null, type: IncidentType, penaltyAmount?: number | null, penaltyComment?: string | null, createdByUser: { __typename?: 'UserGraphql', firstName?: string | null, lastName?: string | null }, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, id: string, signedUrl: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } } };

export type UpdateIncidentMutationVariables = Exact<{
  input: UpdateIncidentGraphqlInput;
}>;


export type UpdateIncidentMutation = { __typename?: 'Mutation', updateIncident: { __typename?: 'AccessibilityIncidentGraphql', comment?: string | null, id: string, penaltyAmount?: number | null, penaltyComment?: string | null, type: IncidentType, updatedAt?: any | null, createdAt: any, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } } | { __typename?: 'MaterialUnavailableIncidentGraphql', comment?: string | null, id: string, penaltyAmount?: number | null, penaltyComment?: string | null, type: IncidentType, updatedAt?: any | null, createdAt: any, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } } | { __typename?: 'NonConformityIncidentGraphql', comment?: string | null, id: string, penaltyAmount?: number | null, penaltyComment?: string | null, type: IncidentType, updatedAt?: any | null, createdAt: any, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } } | { __typename?: 'OtherIncidentGraphql', comment?: string | null, id: string, penaltyAmount?: number | null, penaltyComment?: string | null, type: IncidentType, updatedAt?: any | null, createdAt: any, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } } };

export type IncidentsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArgs>;
  filters: IncidentFiltersGraphql;
}>;


export type IncidentsQuery = { __typename?: 'Query', incidents: { __typename?: 'IncidentCollection', count: number, collection: Array<{ __typename?: 'AccessibilityIncidentGraphql', id: string, penaltyAmount?: number | null, penaltyComment?: string | null, type: IncidentType, updatedAt?: any | null, createdAt: any, comment?: string | null, status: IncidentStatus, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> }, createdByUser: { __typename?: 'UserGraphql', id: string, firstName?: string | null, function?: string | null, email?: string | null, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } } | { __typename?: 'MaterialUnavailableIncidentGraphql', id: string, penaltyAmount?: number | null, penaltyComment?: string | null, type: IncidentType, updatedAt?: any | null, createdAt: any, comment?: string | null, status: IncidentStatus, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> }, createdByUser: { __typename?: 'UserGraphql', id: string, firstName?: string | null, function?: string | null, email?: string | null, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } } | { __typename?: 'NonConformityIncidentGraphql', id: string, penaltyAmount?: number | null, penaltyComment?: string | null, type: IncidentType, updatedAt?: any | null, createdAt: any, comment?: string | null, status: IncidentStatus, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> }, createdByUser: { __typename?: 'UserGraphql', id: string, firstName?: string | null, function?: string | null, email?: string | null, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } } | { __typename?: 'OtherIncidentGraphql', id: string, penaltyAmount?: number | null, penaltyComment?: string | null, type: IncidentType, updatedAt?: any | null, createdAt: any, comment?: string | null, status: IncidentStatus, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', name: string, signedUrl: string, type: DocumentType, id: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> }, createdByUser: { __typename?: 'UserGraphql', id: string, firstName?: string | null, function?: string | null, email?: string | null, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } } | null> } };

export type DeleteIncidentMutationVariables = Exact<{
  input: UpdateIncidentGraphqlInput;
}>;


export type DeleteIncidentMutation = { __typename?: 'Mutation', deleteIncident: { __typename?: 'AccessibilityIncidentGraphql', id: string } | { __typename?: 'MaterialUnavailableIncidentGraphql', id: string } | { __typename?: 'NonConformityIncidentGraphql', id: string } | { __typename?: 'OtherIncidentGraphql', id: string } };

export type InviteRecyclerMutationVariables = Exact<{
  input: InviteRecyclerToProducerInputGraphql;
}>;


export type InviteRecyclerMutation = { __typename?: 'Mutation', inviteRecycler: { __typename?: 'ProducerGraphql', id: string } };

export type AcceptInvitationMutationVariables = Exact<{
  input: AcceptInvitationInput;
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'UserGraphql', id: string } };

export type InvoicedServicesQueryVariables = Exact<{
  filters: InvoicedServicesGraphqlFilter;
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type InvoicedServicesQuery = { __typename?: 'Query', invoicedServices: { __typename?: 'InvoicedServiceCollection', count: number, collection: Array<{ __typename?: 'InvoicedServiceGraphql', createdAt: any, description: string, endsAt?: any | null, id: string, isRecurring: boolean, name: string, startsAt: any, value: number, vat: number, producer: { __typename?: 'ProducerGraphql', id: string, name: string }, recycler: { __typename?: 'RecyclerGraphql', id: string, name: string } } | null> } };

export type AddInvoicedServiceMutationVariables = Exact<{
  input: CreateInvoicedServiceInputGraphql;
}>;


export type AddInvoicedServiceMutation = { __typename?: 'Mutation', addInvoicedService: { __typename?: 'InvoicedServiceGraphql', id: string, endsAt?: any | null, description: string, createdAt: any, isRecurring: boolean, name: string, startsAt: any, value: number, vat: number, producer: { __typename?: 'ProducerGraphql', id: string, name: string }, recycler: { __typename?: 'RecyclerGraphql', id: string, name: string } } };

export type UpdateInvoicedServiceMutationVariables = Exact<{
  input: InvoicedServiceInputGraphql;
}>;


export type UpdateInvoicedServiceMutation = { __typename?: 'Mutation', updateInvoicedService: { __typename?: 'InvoicedServiceGraphql', createdAt: any, description: string, endsAt?: any | null, id: string, name: string, value: number, vat: number, startsAt: any, isRecurring: boolean, producer: { __typename?: 'ProducerGraphql', id: string, name: string }, recycler: { __typename?: 'RecyclerGraphql', id: string, name: string } } };

export type DeleteInvoicedServiceMutationVariables = Exact<{
  input: DeleteInvoicedServiceInputGraphql;
}>;


export type DeleteInvoicedServiceMutation = { __typename?: 'Mutation', deleteInvoicedService: { __typename?: 'InvoicedServiceGraphql', id: string } };

export type ImportSpreadsheetMutationVariables = Exact<{ [key: string]: never; }>;


export type ImportSpreadsheetMutation = { __typename?: 'Mutation', importSpreadsheet: boolean };

export type CreateMaterialMutationVariables = Exact<{
  input: CreateMaterialInputGraphql;
}>;


export type CreateMaterialMutation = { __typename?: 'Mutation', createMaterial: { __typename?: 'MaterialGraphql', id: string } };

export type UpdateMaterialMutationVariables = Exact<{
  input: UpdateMaterialInputGraphql;
}>;


export type UpdateMaterialMutation = { __typename?: 'Mutation', updateMaterial: { __typename?: 'MaterialGraphql', id: string } };

export type StandardMaterialsQueryVariables = Exact<{
  filters: StandardMaterialFilters;
}>;


export type StandardMaterialsQuery = { __typename?: 'Query', standardMaterials: { __typename?: 'StandardMaterialCollection', collection: Array<{ __typename?: 'StandardMaterialGraphql', attributes: string, reference: string, category: string, consistency: MaterialConsistence, subCategory: string, isDangerous: boolean, id: string, shape: string, name: string } | null> } };

export type AvailableCategoriesAndSubcategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableCategoriesAndSubcategoriesQuery = { __typename?: 'Query', availableCategoriesAndSubcategories: Array<{ __typename?: 'AvailableCategories', category: string, subcategories: Array<string | null> }> };

export type MaterialsForSelectQueryVariables = Exact<{
  filters: MaterialFiltersGraphql;
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type MaterialsForSelectQuery = { __typename?: 'Query', materials: { __typename?: 'MaterialCollection', count: number, collection: Array<{ __typename?: 'MaterialGraphql', capCode?: string | null, consistency: MaterialConsistence, id: string, price?: number | null, isSold?: boolean | null, name: string, wasteCode?: string | null, recycler?: { __typename?: 'RecyclerGraphql', name: string, id: string, isPremiumRecycler?: boolean | null } | null, container: Array<{ __typename?: 'ContainerGraphql', id: string, name?: string | null }> } | null> } };

export type MaterialQueryVariables = Exact<{
  filters: MaterialFiltersGraphql;
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type MaterialQuery = { __typename?: 'Query', materials: { __typename?: 'MaterialCollection', collection: Array<{ __typename?: 'MaterialGraphql', id: string, isSold?: boolean | null, name: string, capCode?: string | null, consistency: MaterialConsistence, price?: number | null, wasteCode?: string | null, pricingForCurrentRecycler?: { __typename?: 'DefaultPricingGraphql', id: string, price: number, vat: number } | { __typename?: 'WPSpecificPricingGraphql', id: string, price: number, vat: number } | null, recycler?: { __typename?: 'RecyclerGraphql', name: string, id: string } | null, standardMaterial: { __typename?: 'StandardMaterialGraphql', attributes: string, category: string, consistency: MaterialConsistence, subCategory: string, isDangerous: boolean, id: string, name: string }, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', extension: string, id: string, name: string, signedUrl: string, type: DocumentType, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } } | null> } };

export type DeleteMaterialMutationVariables = Exact<{
  input: DeleteMaterialInputGraphql;
}>;


export type DeleteMaterialMutation = { __typename?: 'Mutation', deleteMaterial: { __typename?: 'MaterialGraphql', id: string } };

export type OrganizationsQueryVariables = Exact<{
  filters?: InputMaybe<OrganizationFiltersGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
  companiesPagination2?: InputMaybe<PaginationArgs>;
}>;


export type OrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationCollection', count: number, collection: Array<{ __typename?: 'OrganizationGraphql', name: string, id: string, type: OrganizationType, companies: { __typename?: 'ClientCollection', collection: Array<{ __typename?: 'ProducerGraphql', bsdCreationEnabledForMaterials?: TdOptionsMaterialTypes | null, type: ClientType, name: string, id: string, customDashboardId?: number | null } | { __typename?: 'RecyclerGraphql', type: ClientType, name: string, id: string, customDashboardId?: number | null } | null> } } | null> } };

export type OrganizationsForSelectQueryVariables = Exact<{
  filters?: InputMaybe<OrganizationFiltersGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type OrganizationsForSelectQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationCollection', count: number, collection: Array<{ __typename?: 'OrganizationGraphql', name: string, id: string, type: OrganizationType } | null> } };

export type OrganizationQueryVariables = Exact<{
  filters?: InputMaybe<OrganizationFiltersGraphql>;
  pagination?: InputMaybe<PaginationArgs>;
  companiesPagination?: InputMaybe<PaginationArgs>;
}>;


export type OrganizationQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationCollection', count: number, collection: Array<{ __typename?: 'OrganizationGraphql', name: string, id: string, type: OrganizationType, treatmentCodes?: Array<{ __typename?: 'CustomTreatmentCodeGraphql', code: TreatmentCodeKey, description: string, isRemapped?: boolean | null } | { __typename?: 'RegularTreatmentCodeGraphql', code: TreatmentCodeKey, description: string, isRemapped?: boolean | null }> | null, companies: { __typename?: 'ClientCollection', collection: Array<{ __typename?: 'ProducerGraphql', bsdCreationEnabledForMaterials?: TdOptionsMaterialTypes | null, siret?: string | null, id: string, name: string, contactFirstName?: string | null, contactLastName?: string | null, type: ClientType, onboardingDone?: boolean | null, onboardingNeeds?: string | null, customDashboardId?: number | null, organization: { __typename?: 'OrganizationGraphql', id: string } } | { __typename?: 'RecyclerGraphql', siret?: string | null, id: string, name: string, contactFirstName?: string | null, contactLastName?: string | null, type: ClientType, onboardingDone?: boolean | null, onboardingNeeds?: string | null, customDashboardId?: number | null, organization: { __typename?: 'OrganizationGraphql', id: string } } | null> } } | null> } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'OrganizationGraphql', id: string } };

export type MaterialPricingsPerMaterialQueryVariables = Exact<{
  filters: MaterialPricingGraphqlFilters;
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type MaterialPricingsPerMaterialQuery = { __typename?: 'Query', materialPricingsPerMaterial: { __typename?: 'MaterialPricingPerMaterialCollection', count: number, collection: Array<{ __typename?: 'MaterialPricingPerMaterialGraphql', price: number, vat: number, shouldBeUpdatedAt: any, id: string, correlationId: string, details: { __typename?: 'MaterialPricingDetails', VATAmount: number, totalRevshareEugene?: number | null, totalWithVAT: number, totalWithoutVAT: number }, updateFrequency: { __typename?: 'FrequencyGraphql', unit: string, value: number }, standardMaterial?: { __typename?: 'StandardMaterialGraphql', id: string, consistency: MaterialConsistence, category: string, attributes: string, name: string, reference: string, isDangerous: boolean, shape: string, subCategory: string } | null, producerPricings: { __typename?: 'MaterialPricingCollection', collection: Array<{ __typename?: 'DefaultPricingGraphql', createdAt: any, id: string, details: { __typename?: 'MaterialPricingDetails', totalRevshareEugene?: number | null, VATAmount: number, totalWithVAT: number, totalWithoutVAT: number }, targetProducer?: { __typename?: 'ProducerGraphql', id: string, name: string } | null } | { __typename?: 'WPSpecificPricingGraphql', createdAt: any, id: string, details: { __typename?: 'MaterialPricingDetails', totalRevshareEugene?: number | null, VATAmount: number, totalWithVAT: number, totalWithoutVAT: number }, targetProducer?: { __typename?: 'ProducerGraphql', id: string, name: string } | null } | null> } } | null> } };

export type AddNewMaterialPricingMutationVariables = Exact<{
  input: AddNewMaterialPricingGraphqlInput;
}>;


export type AddNewMaterialPricingMutation = { __typename?: 'Mutation', addNewMaterialPricing: { __typename?: 'DefaultPricingGraphql', id: string, price: number, shouldBeUpdatedAt: any, vat: number, updateFrequency: { __typename?: 'FrequencyGraphql', value: number, unit: string }, details: { __typename?: 'MaterialPricingDetails', VATAmount: number, totalRevshareEugene?: number | null, totalWithVAT: number, totalWithoutVAT: number }, targetProducer?: { __typename?: 'ProducerGraphql', id: string, name: string } | null } | { __typename?: 'WPSpecificPricingGraphql', id: string, price: number, shouldBeUpdatedAt: any, vat: number, updateFrequency: { __typename?: 'FrequencyGraphql', value: number, unit: string }, details: { __typename?: 'MaterialPricingDetails', VATAmount: number, totalRevshareEugene?: number | null, totalWithVAT: number, totalWithoutVAT: number }, targetProducer?: { __typename?: 'ProducerGraphql', id: string, name: string } | null } };

export type PricingListQueryVariables = Exact<{
  filters: PricingFiltersGraphql;
}>;


export type PricingListQuery = { __typename?: 'Query', pricingsv1: { __typename?: 'PriceListCollection', collection: Array<{ __typename?: 'PricingGraphql', vat: number, unit: string, price: number, id: string, status: PriceListStatus, createdAt: any, producer: { __typename?: 'ProducerGraphql', id: string, name: string }, material: { __typename?: 'MaterialGraphql', id: string, isSold?: boolean | null, name: string, pricingForCurrentRecycler?: { __typename?: 'DefaultPricingGraphql', id: string, price: number, vat: number } | { __typename?: 'WPSpecificPricingGraphql', id: string, price: number, vat: number } | null, documents: { __typename?: 'StoredDocumentCollection', collection: Array<{ __typename?: 'ClientDocumentGraphql', signedUrl: string, id: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectDocumentGraphql', signedUrl: string, id: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'CollectedContainerDocumentGraphql', signedUrl: string, id: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ContainerDocumentGraphql', signedUrl: string, id: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'IncidentDocumentGraphql', signedUrl: string, id: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'MaterialDocumentGraphql', signedUrl: string, id: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | { __typename?: 'ProducerRequestDocumentGraphql', signedUrl: string, id: string, name: string, client: { __typename?: 'ProducerGraphql', id: string } | { __typename?: 'RecyclerGraphql', id: string } } | null> } } } | null> } };

export type CreatePricingMutationVariables = Exact<{
  input: CreatePricingInputGraphql;
}>;


export type CreatePricingMutation = { __typename?: 'Mutation', createPricing: { __typename?: 'PricingGraphql', id: string } };

export type RolesQueryVariables = Exact<{
  filters?: InputMaybe<RolesInputGraphql>;
}>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename: 'CompanyRole', id: string, name: string, company: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } | { __typename: 'OrganizationRole', id: string, name: string, organization: { __typename?: 'OrganizationGraphql', id: string, name: string } } | { __typename: 'SiteRole', id: string, name: string, site: { __typename?: 'SiteGraphql', id: string, name?: string | null } }> };

export type AssignRoleToUserMutationVariables = Exact<{
  input: AssignRoleInput;
}>;


export type AssignRoleToUserMutation = { __typename?: 'Mutation', assignRoleToUser: { __typename?: 'AssignedRoleGraphql', id: string } };

export type RemoveRoleFromUserMutationVariables = Exact<{
  input: AssignRoleInput;
}>;


export type RemoveRoleFromUserMutation = { __typename?: 'Mutation', removeRoleFromUser: boolean };

export type SitesQueryVariables = Exact<{
  filters: SitesFilterGraphql;
  pagination?: InputMaybe<PaginationArgs>;
}>;


export type SitesQuery = { __typename?: 'Query', sites: { __typename?: 'SitesCollection', count: number, collection: Array<{ __typename?: 'SiteGraphql', address?: string | null, id: string, name?: string | null, zipCode?: string | null, collectsInformations?: string | null, client: { __typename?: 'ProducerGraphql', id: string, name: string, siret?: string | null } | { __typename?: 'RecyclerGraphql', id: string, name: string, siret?: string | null }, containers: { __typename?: 'ContainerCollection', collection: Array<{ __typename?: 'ContainerGraphql', name?: string | null, id: string } | null> }, openingHours?: { __typename?: 'SiteOpeningHoursGraphql', friday?: Array<{ __typename?: 'SiteOpeningHourGraphql', open: string, close: string }> | null, monday?: Array<{ __typename?: 'SiteOpeningHourGraphql', open: string, close: string }> | null, saturday?: Array<{ __typename?: 'SiteOpeningHourGraphql', open: string, close: string }> | null, sunday?: Array<{ __typename?: 'SiteOpeningHourGraphql', open: string, close: string }> | null, thursday?: Array<{ __typename?: 'SiteOpeningHourGraphql', open: string, close: string }> | null, tuesday?: Array<{ __typename?: 'SiteOpeningHourGraphql', open: string, close: string }> | null, wednesday?: Array<{ __typename?: 'SiteOpeningHourGraphql', open: string, close: string }> | null } | null } | null> } };

export type SitesForSelectQueryVariables = Exact<{
  filters: SitesFilterGraphql;
}>;


export type SitesForSelectQuery = { __typename?: 'Query', sites: { __typename?: 'SitesCollection', collection: Array<{ __typename?: 'SiteGraphql', id: string, name?: string | null } | null> } };

export type UpsertSiteMutationVariables = Exact<{
  input: SiteInputGraphql;
}>;


export type UpsertSiteMutation = { __typename?: 'Mutation', upsertSite: { __typename?: 'SiteGraphql', address?: string | null, id: string, name?: string | null, zipCode?: string | null, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } };

export type SearchCompaniesQueryVariables = Exact<{
  filters: SearchCompanyFilters;
}>;


export type SearchCompaniesQuery = { __typename?: 'Query', searchCompanies: Array<{ __typename: 'CompanySearchResultGraphql', companyName?: string | null, naf?: string | null, address?: string | null, isRegistered?: boolean | null, siret?: string | null, email?: string | null, allowBSDASRITakeOverWithoutSignature?: boolean | null, legalName?: string | null, phone?: string | null, contact?: string | null, existsInCinqo: boolean, transporterReceipt?: { __typename?: 'TransporterReceiptGraphql', id?: string | null, receiptNumber?: string | null, expiresAt?: any | null, department?: string | null } | null }> };

export type SearchCompaniesPublicQueryVariables = Exact<{
  filters: SearchCompanyFilters;
}>;


export type SearchCompaniesPublicQuery = { __typename?: 'Query', searchCompaniesPublic: Array<{ __typename: 'CompanySearchResultGraphql', companyName?: string | null, naf?: string | null, address?: string | null, isRegistered?: boolean | null, siret?: string | null, email?: string | null, allowBSDASRITakeOverWithoutSignature?: boolean | null, legalName?: string | null, phone?: string | null, contact?: string | null, existsInCinqo: boolean, transporterReceipt?: { __typename?: 'TransporterReceiptGraphql', id?: string | null, receiptNumber?: string | null, expiresAt?: any | null, department?: string | null } | null }> };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'UserGraphql', email?: string | null, firstName?: string | null, id: string, lastName?: string | null, role: UserRoles, client: { __typename?: 'ProducerGraphql', name: string } | { __typename?: 'RecyclerGraphql', name: string } } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserGraphql', disabled?: boolean | null, email?: string | null, firstName?: string | null, function?: string | null, id: string, lastName?: string | null, role: UserRoles, client: { __typename?: 'ProducerGraphql', name: string } | { __typename?: 'RecyclerGraphql', name: string } } };

export type AcceptCguMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptCguMutation = { __typename?: 'Mutation', acceptCGU: boolean };

export type UsersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationArgs>;
  filters?: InputMaybe<UserFilterGraphql>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UserCollection', count: number, collection: Array<{ __typename?: 'UserGraphql', role: UserRoles, lastName?: string | null, id: string, firstName?: string | null, email?: string | null, function?: string | null, disabled?: boolean | null, client: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string }, assignedRoles: { __typename?: 'AssignedRolesCollection', collection: Array<{ __typename?: 'AssignedRoleGraphql', role: { __typename: 'CompanyRole', id: string, name: string, company: { __typename?: 'ProducerGraphql', id: string, name: string } | { __typename?: 'RecyclerGraphql', id: string, name: string } } | { __typename: 'OrganizationRole', id: string, name: string, organization: { __typename?: 'OrganizationGraphql', id: string, name: string } } | { __typename: 'SiteRole', id: string, name: string, site: { __typename?: 'SiteGraphql', id: string, name?: string | null } } } | null> }, entitlements: { __typename?: 'EntitlementsGraphql', companies?: Array<{ __typename?: 'LocationEntitlementGraphql', id?: string | null, role?: string | null }> | null, organisations?: Array<{ __typename?: 'LocationEntitlementGraphql', id?: string | null, role?: string | null }> | null, sites?: Array<{ __typename?: 'LocationEntitlementGraphql', id?: string | null, role?: string | null }> | null } } | null> } };

export type ToggleTrackdechetsAutosignMutationVariables = Exact<{ [key: string]: never; }>;


export type ToggleTrackdechetsAutosignMutation = { __typename?: 'Mutation', toggleTrackdechetsAutosign: { __typename?: 'ProducerGraphql', autosignEnabledForTrackdechets: boolean, id: string, isConnectedToTrackdechets?: boolean | null, name: string, slug: string, sites: { __typename?: 'SitesCollection', collection: Array<{ __typename?: 'SiteGraphql', address?: string | null, id: string, name?: string | null, zipCode?: string | null } | null> } } | { __typename?: 'RecyclerGraphql', autosignEnabledForTrackdechets: boolean, id: string, isConnectedToTrackdechets?: boolean | null, name: string, slug: string, sites: { __typename?: 'SitesCollection', collection: Array<{ __typename?: 'SiteGraphql', address?: string | null, id: string, name?: string | null, zipCode?: string | null } | null> } } };

export type WelcomeScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type WelcomeScreenQuery = { __typename?: 'Query', welcomeScreen: { __typename?: 'ProducerWelcomeScreenGraphql', collectWithIncidents?: number | null, bsdToSign?: number | null, incomingCollects?: number | null } | { __typename?: 'RecyclerWelcomeScreenGraphql', materialPriceToUpdate?: number | null, materialWithoutPrice?: number | null, collectsWithMissingFields?: number | null, bsdToSign?: number | null, incomingCollects?: number | null } };
